import {
  ActivityTemplateDetailPageData,
  ActivityTemplateStatus,
  ActivityTemplatesPageData,
  ActivityTypesPageData,
  ActivityRegistryPageData,
  AdminClientClinician,
  AdminClientPatient,
  AdminClientsPageData,
  AdminClinic,
  CaseloadEngagementPageData,
  CaseloadEngagementPeriod,
  CaseloadEngagementReport,
  CaseloadHomeworkClient,
  CaseloadMessageClient,
  CaseloadNoActivityClient,
  ClinicsPageData,
  ClientValue,
  ClientValuesData,
  ValueEngagementActivityOption,
  ValueEngagementAssignment,
  ValueEngagementClient,
  ValueEngagementMetric,
  ValueEngagementReportData,
  HomeworkOverviewClientOption,
  HomeworkOverviewClinicalMetrics,
  HomeworkOverviewPeriod,
  HomeworkOverviewReportData,
  HomeworkOverviewSummary,
  CompletionByDeviceActivityOption,
  CompletionByDeviceBreakdownItem,
  CompletionByDeviceClientOption,
  CompletionByDeviceKey,
  CompletionByDevicePeriod,
  CompletionByDeviceReportData,
  CompletionByDeviceSummary,
  DashboardAttentionEventType,
  DashboardAttentionEngagementClient,
  DashboardAttentionEngagementStatus,
  DashboardAttentionInactiveClient,
  DashboardAttentionReportData,
  DashboardAttentionSafetyClient,
  DashboardAttentionSummary,
  ClientRankLevelRule,
  ClientRankLevelRulesData,
  ClientRecordAccess,
  ClientCopingSkillsData,
  ClientProfilePageData,
  CopingSkillGuide,
  CopingSkillsData,
  CreateClientData,
  CreateClientValueData,
  CreateClientRankLevelRuleData,
  CreateCopingSkillData,
  CreateClientCopingSkillData,
  CreateTherapistData,
  CreatedPortalTherapist,
  CreateClinicData,
  UpdateClinicData,
  UpdateTherapistData,
  CreateActivityTemplateData,
  CreateLovOptionData,
  CreateHomeworkData,
  CreateHomeworkActivityData,
  ClinicianPortalApiEnvelope,
  ClinicianPortalApiFailure,
  ClinicianPortalErrorCode,
  ClinicianAssistantClarification,
  ClinicianAssistantEvidence,
  ClinicianAssistantLink,
  ClinicianAssistantLinkPage,
  ClinicianAssistantResult,
  CurrentHomeworkAssignment,
  CurrentHomeworkPageData,
  CurrentHomeworkTemplateOption,
  DailyMoodCheck,
  DailyMoodChecksPageData,
  YouthTopProblemRating,
  YouthTopProblemRatingsPageData,
  ExpectancyEntry,
  ExpectanciesPageData,
  ExpectancyPredictionResult,
  DeleteHomeworkData,
  DuplicateHomeworkData,
  GenerateHomeworkAnalysisData,
  HomeworkEngagement,
  HomeworkActivitiesPageData,
  HomeworkDetailPageData,
  HomeworkCompletionStatus,
  HomeworkHistoryAssignment,
  HomeworkHistoryFilter,
  HomeworkHistoryPageData,
  ClientSessionsPageData,
  ClientSessionTranscriptData,
  ClientSessionFilter,
  clientSessionFilters,
  HomeworkHistoryStatus,
  HomeworkCalendarAssignment,
  HomeworkCalendarPageData,
  HomeworkCalendarStatus,
  UnscheduledHomeworkAssignment,
  HomeworkAnalysesPageData,
  LovCatalog,
  LovCatalogWithOptions,
  LovCatalogsPageData,
  LovOption,
  LovOrderingMode,
  LovOptionsPageData,
  MyClientsPageData,
  SupervisorClinicOption,
  SupervisorClinicSummary,
  SupervisorMembershipRole,
  SupervisorTeamMember,
  SupervisorTeamMembership,
  SupervisorTeamClient,
  SupervisorTeamClientDetailData,
  SupervisorTeamClientsData,
  SupervisorTeamHomeworkDetailData,
  SupervisorTeamHomeworkData,
  SupervisorTeamReportsData,
  SupervisorTeamAttentionClient,
  SupervisorTeamAttentionData,
  SupervisorTeamAttentionEngagementClient,
  SupervisorTeamAttentionSafetyClient,
  SupervisorTeamOverviewData,
  PortalClientMutationPatient,
  PortalFormFieldType,
  PortalRecordFormField,
  PortalRelationOption,
  RankLevel,
  RankLevelsData,
  PortalActivityImage,
  PortalActivityType,
  PortalActivityRegistryItem,
  PortalActivityTemplateDetail,
  PortalActivityTemplateRecord,
  PortalActivityTemplateSummary,
  PortalHomeworkActivitiesListAssignment,
  PortalHomeworkActivitySummary,
  PortalHomeworkDetail,
  PortalHomeworkAnalysis,
  PortalOperation,
  PortalTableKey,
  PortalTablePreference,
  PortalMutationHomework,
  PortalPatient,
  PortalTherapist,
  RecordFormConfigData,
  RelationOptionsData,
  AdminTherapistRole,
  TherapistsPageData,
  TablePreferencesData,
  SelectHomeworkTemplateData,
  SetClientValueEnabledData,
  SetClientRankLevelRuleEnabledData,
  SetCopingSkillEnabledData,
  SetClientCopingSkillEnabledData,
  SetLovOptionEnabledData,
  UpdateActivityTemplateData,
  UpdateActivityTemplateStepsData,
  UploadActivityTemplateImageData,
  DeleteActivityTemplateImageData,
  UploadHomeworkImageData,
  DeleteHomeworkImageData,
  UpdateHomeworkData,
  UpdateHomeworkStepsData,
  UpdateClientData,
  UpdateClientValueData,
  UpdateClientRankLevelRuleData,
  UpdateCopingSkillData,
  UpdateClientCopingSkillData,
  UpdateLovOptionData,
  homeworkHistoryFilters,
  homeworkCalendarStatuses,
  caseloadEngagementPeriods,
  homeworkOverviewPeriods,
  completionByDevicePeriods,
  dashboardAttentionEngagementStatuses,
  homeworkCompletionStatuses,
  expectancyPredictionResults,
  portalOperations,
  Weekday,
  weekdays,
} from "./contracts";

export class ClinicianPortalContractError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ClinicianPortalContractError";
  }
}

type JsonObject = Record<string, unknown>;

function invalid(path: string): never {
  throw new ClinicianPortalContractError(
    `The Clinician Portal API response is invalid at ${path}.`,
  );
}

function objectAt(value: unknown, path: string): JsonObject {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return invalid(path);
  }
  return value as JsonObject;
}

function stringAt(value: unknown, path: string): string {
  if (typeof value !== "string") return invalid(path);
  return value;
}

function optionalStringAt(value: unknown, path: string): string | undefined {
  return value === undefined ? undefined : stringAt(value, path);
}

function nonEmptyStringAt(value: unknown, path: string): string {
  const parsed = stringAt(value, path);
  if (!parsed.trim()) return invalid(path);
  return parsed;
}

function booleanAt(value: unknown, path: string): boolean {
  if (typeof value !== "boolean") return invalid(path);
  return value;
}

function finiteNumberAt(value: unknown, path: string): number {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return invalid(path);
  }
  return value;
}

function integerAt(value: unknown, path: string): number {
  const parsed = finiteNumberAt(value, path);
  if (!Number.isInteger(parsed)) return invalid(path);
  return parsed;
}

function nonNegativeIntegerAt(value: unknown, path: string): number {
  const parsed = integerAt(value, path);
  if (parsed < 0) return invalid(path);
  return parsed;
}

function nullableNumberAt(value: unknown, path: string): number | null {
  return value === null ? null : finiteNumberAt(value, path);
}

function numberOrBlankAt(value: unknown, path: string): number | "" {
  return value === "" ? "" : finiteNumberAt(value, path);
}

function nullableStringAt(value: unknown, path: string): string | null {
  return value === null ? null : stringAt(value, path);
}

function calendarDateAt(value: unknown, path: string): string {
  const parsed = stringAt(value, path);
  const match = parsed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return invalid(path);

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return invalid(path);
  }
  return parsed;
}

function nullableRatingAt(value: unknown, path: string): number | null {
  if (value === null) return null;
  const parsed = finiteNumberAt(value, path);
  if (!Number.isInteger(parsed) || parsed < 0 || parsed > 10) {
    return invalid(path);
  }
  return parsed;
}

function stringArrayAt(value: unknown, path: string): string[] {
  if (!Array.isArray(value)) return invalid(path);
  return value.map((entry, index) => stringAt(entry, `${path}[${index}]`));
}

const portalTableKeys: readonly PortalTableKey[] = [
  "my_clients",
  "homework_activities",
  "current_homework",
  "homework_history",
];

function portalTableKeyAt(value: unknown, path: string): PortalTableKey {
  const key = stringAt(value, path);
  if (!portalTableKeys.includes(key as PortalTableKey)) return invalid(path);
  return key as PortalTableKey;
}

function columnWidthsAt(value: unknown, path: string): Record<string, number> {
  const record = objectAt(value, path);
  return Object.fromEntries(
    Object.entries(record).map(([key, width]) => {
      const parsedWidth = finiteNumberAt(width, `${path}.${key}`);
      if (
        !Number.isInteger(parsedWidth) ||
        parsedWidth < 48 ||
        parsedWidth > 1200
      ) {
        return invalid(`${path}.${key}`);
      }
      return [key, parsedWidth];
    }),
  );
}

function tablePreferenceAt(
  value: unknown,
  path: string,
): PortalTablePreference {
  const record = objectAt(value, path);
  return {
    tableKey: portalTableKeyAt(record.tableKey, `${path}.tableKey`),
    columnOrder: stringArrayAt(record.columnOrder, `${path}.columnOrder`),
    hiddenColumns: stringArrayAt(record.hiddenColumns, `${path}.hiddenColumns`),
    columnWidths: columnWidthsAt(record.columnWidths, `${path}.columnWidths`),
    schemaVersion: integerAt(record.schemaVersion, `${path}.schemaVersion`),
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: stringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

function therapistAt(value: unknown, path: string): PortalTherapist {
  const record = objectAt(value, path);
  const advancedDashboardEnabledValue =
    record.advancedDashboardEnabled !== undefined
      ? record.advancedDashboardEnabled
      : record.advanced_dashboard_enabled;
  const lastPortalActiveAtValue = record.lastPortalActiveAt !== undefined
    ? record.lastPortalActiveAt : record.last_portal_active_at;
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    therapistName: stringAt(record.therapistName, `${path}.therapistName`),
    email: stringAt(record.email, `${path}.email`),
    clinicianCode: stringAt(record.clinicianCode, `${path}.clinicianCode`),
    status: stringAt(record.status, `${path}.status`),
    role: stringAt(record.role, `${path}.role`),
    advancedDashboardEnabled:
      advancedDashboardEnabledValue === undefined
        ? true
        : booleanAt(
            advancedDashboardEnabledValue,
            `${path}.advancedDashboardEnabled`,
          ),
    clinicNames:
      record.clinicNames === undefined
        ? undefined
        : stringArrayAt(record.clinicNames, `${path}.clinicNames`),
    ...(lastPortalActiveAtValue === undefined ? {} : {
      lastPortalActiveAt: lastPortalActiveAtValue === null ? null
        : timestampAt(lastPortalActiveAtValue, `${path}.lastPortalActiveAt`),
    }),
  };
}

function nullableTherapistAt(
  value: unknown,
  path: string,
): PortalTherapist | null {
  return value === null ? null : therapistAt(value, path);
}

function adminTherapistRoleAt(
  value: unknown,
  path: string,
): AdminTherapistRole {
  const role = stringAt(value, path);
  if (role !== "therapist" && role !== "supervisor" && role !== "admin") {
    return invalid(path);
  }
  return role;
}

function createdTherapistAt(
  value: unknown,
  path: string,
): CreatedPortalTherapist {
  const record = objectAt(value, path);
  const normalizedTherapist = therapistAt(record, path);
  const clinicIds = stringArrayAt(record.clinicIds, `${path}.clinicIds`).map(
    (clinicId, index) =>
      nonEmptyStringAt(clinicId, `${path}.clinicIds[${index}]`),
  );
  const clinicCount = finiteNumberAt(record.clinicCount, `${path}.clinicCount`);
  if (!Number.isInteger(clinicCount) || clinicCount < 0) {
    return invalid(`${path}.clinicCount`);
  }
  if (clinicCount !== clinicIds.length) {
    return invalid(`${path}.clinicCount`);
  }

  return {
    ...normalizedTherapist,
    role: adminTherapistRoleAt(record.role, `${path}.role`),
    clinicIds,
    clinicCount,
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: stringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

function patientAt(value: unknown, path: string): PortalPatient {
  const record = objectAt(value, path);
  const coins = record.coins ?? record.coinsEarned;
  const badgeLevel = record.badgeLevel ?? record.rank;
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    accessCode: stringAt(record.accessCode, `${path}.accessCode`),
    clinicId: stringAt(record.clinicId, `${path}.clinicId`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    status: stringAt(record.status, `${path}.status`),
    clinicalSummary: stringAt(
      record.clinicalSummary,
      `${path}.clinicalSummary`,
    ),
    highSudsThreshold: finiteNumberAt(
      record.highSudsThreshold,
      `${path}.highSudsThreshold`,
    ),
    sudsInputStyle: stringAt(record.sudsInputStyle, `${path}.sudsInputStyle`),
    selfInitiatedPermitted: booleanAt(
      record.selfInitiatedPermitted,
      `${path}.selfInitiatedPermitted`,
    ),
    copingStrategies: stringArrayAt(
      record.copingStrategies,
      `${path}.copingStrategies`,
    ),
    funActivities: stringArrayAt(record.funActivities, `${path}.funActivities`),
    pointsEarned: finiteNumberAt(record.pointsEarned, `${path}.pointsEarned`),
    coins: finiteNumberAt(coins, `${path}.coins`),
    badgeLevel: stringAt(badgeLevel, `${path}.badgeLevel`),
    badgeCollection: stringArrayAt(
      record.badgeCollection,
      `${path}.badgeCollection`,
    ),
  };
}

function adminClientClinicianAt(
  value: unknown,
  path: string,
): AdminClientClinician {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    therapistName: stringAt(record.therapistName, `${path}.therapistName`),
    email: stringAt(record.email, `${path}.email`),
    clinicianCode: stringAt(record.clinicianCode, `${path}.clinicianCode`),
    status: stringAt(record.status, `${path}.status`),
  };
}

function adminClientPatientAt(
  value: unknown,
  path: string,
): AdminClientPatient {
  const record = objectAt(value, path);
  const clinic =
    record.clinic === null
      ? null
      : (() => {
          const clinicRecord = objectAt(record.clinic, `${path}.clinic`);
          return {
            id: nonEmptyStringAt(clinicRecord.id, `${path}.clinic.id`),
            clinicName: stringAt(
              clinicRecord.clinicName,
              `${path}.clinic.clinicName`,
            ),
            status: stringAt(clinicRecord.status, `${path}.clinic.status`),
          };
        })();

  if (!Array.isArray(record.clinicians)) return invalid(`${path}.clinicians`);
  if (!Array.isArray(record.badgeCollection)) {
    return invalid(`${path}.badgeCollection`);
  }

  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    accessCode: stringAt(record.accessCode, `${path}.accessCode`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    clinician:
      record.clinician === null
        ? null
        : adminClientClinicianAt(record.clinician, `${path}.clinician`),
    clinicianId: stringAt(record.clinicianId, `${path}.clinicianId`),
    clinicianName: stringAt(record.clinicianName, `${path}.clinicianName`),
    clinicianIds: stringArrayAt(record.clinicianIds, `${path}.clinicianIds`),
    clinicianNames: stringArrayAt(
      record.clinicianNames,
      `${path}.clinicianNames`,
    ),
    clinicians: record.clinicians.map((clinician, index) =>
      adminClientClinicianAt(clinician, `${path}.clinicians[${index}]`),
    ),
    clinic,
    clinicId: stringAt(record.clinicId, `${path}.clinicId`),
    clinicName: stringAt(record.clinicName, `${path}.clinicName`),
    status: stringAt(record.status, `${path}.status`),
    clinicalSummary: stringAt(
      record.clinicalSummary,
      `${path}.clinicalSummary`,
    ),
    exposureHierarchyText: stringAt(
      record.exposureHierarchyText,
      `${path}.exposureHierarchyText`,
    ),
    highSudsThreshold: nullableNumberAt(
      record.highSudsThreshold,
      `${path}.highSudsThreshold`,
    ),
    sudsInputStyle: stringAt(record.sudsInputStyle, `${path}.sudsInputStyle`),
    selfInitiatedPermitted: booleanAt(
      record.selfInitiatedPermitted,
      `${path}.selfInitiatedPermitted`,
    ),
    copingStrategies: stringArrayAt(
      record.copingStrategies,
      `${path}.copingStrategies`,
    ),
    funActivities: stringArrayAt(record.funActivities, `${path}.funActivities`),
    pointsEarned: nullableNumberAt(record.pointsEarned, `${path}.pointsEarned`),
    coinsEarned: nullableNumberAt(record.coinsEarned, `${path}.coinsEarned`),
    coins: nullableNumberAt(record.coins, `${path}.coins`),
    rank: stringAt(record.rank, `${path}.rank`),
    badgeLevel: stringAt(record.badgeLevel, `${path}.badgeLevel`),
    badgeCollection: [...record.badgeCollection],
  };
}

function clientMutationPatientAt(
  value: unknown,
  path: string,
): PortalClientMutationPatient {
  const record = objectAt(value, path);
  return {
    ...patientAt(record, path),
    createdAt: nonEmptyStringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: nonEmptyStringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

function nullablePatientAt(value: unknown, path: string): PortalPatient | null {
  return value === null ? null : patientAt(value, path);
}

function clientValueAt(value: unknown, path: string): ClientValue {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    patientId: nonEmptyStringAt(record.patientId, `${path}.patientId`),
    valueName: nonEmptyStringAt(record.valueName, `${path}.valueName`),
    whyImportant: stringAt(record.whyImportant, `${path}.whyImportant`),
    enabled: booleanAt(record.enabled, `${path}.enabled`),
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: stringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

function rankLevelAt(value: unknown, path: string): RankLevel {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    key: nonEmptyStringAt(record.key, `${path}.key`),
    name: nonEmptyStringAt(record.name, `${path}.name`),
    sortOrder: integerAt(record.sortOrder, `${path}.sortOrder`),
    enabled: booleanAt(record.enabled, `${path}.enabled`),
  };
}

function clientRankLevelRuleAt(
  value: unknown,
  path: string,
): ClientRankLevelRule {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    patientId: nonEmptyStringAt(record.patientId, `${path}.patientId`),
    rankLevelId: nonEmptyStringAt(record.rankLevelId, `${path}.rankLevelId`),
    rankLevelKey: nonEmptyStringAt(record.rankLevelKey, `${path}.rankLevelKey`),
    rankLevelName: nonEmptyStringAt(
      record.rankLevelName,
      `${path}.rankLevelName`,
    ),
    thresholdPoints: nonNegativeIntegerAt(
      record.thresholdPoints,
      `${path}.thresholdPoints`,
    ),
    enabled: booleanAt(record.enabled, `${path}.enabled`),
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: stringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

function copingSkillGuideAt(value: unknown, path: string): CopingSkillGuide {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    copingStrategyOptionId: nonEmptyStringAt(
      record.copingStrategyOptionId,
      `${path}.copingStrategyOptionId`,
    ),
    copingStrategyKey: nonEmptyStringAt(
      record.copingStrategyKey,
      `${path}.copingStrategyKey`,
    ),
    copingStrategyValue: nonEmptyStringAt(
      record.copingStrategyValue,
      `${path}.copingStrategyValue`,
    ),
    skillKey: nonEmptyStringAt(record.skillKey, `${path}.skillKey`),
    skillName: nonEmptyStringAt(record.skillName, `${path}.skillName`),
    patientId: nullableStringAt(record.patientId, `${path}.patientId`),
    guideSteps: nonEmptyStringAt(record.guideSteps, `${path}.guideSteps`),
    enabled: booleanAt(record.enabled, `${path}.enabled`),
    copingStrategyEnabled: booleanAt(
      record.copingStrategyEnabled,
      `${path}.copingStrategyEnabled`,
    ),
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: stringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

function engagementAt(value: unknown, path: string): HomeworkEngagement {
  const record = objectAt(value, path);
  return {
    engagementRate: finiteNumberAt(
      record.engagementRate,
      `${path}.engagementRate`,
    ),
    homeworkCompleted: finiteNumberAt(
      record.homeworkCompleted,
      `${path}.homeworkCompleted`,
    ),
    totalAssigned: finiteNumberAt(
      record.totalAssigned,
      `${path}.totalAssigned`,
    ),
  };
}

function currentHomeworkAssignmentAt(
  value: unknown,
  path: string,
): CurrentHomeworkAssignment {
  const record = objectAt(value, path);
  const repeats = stringAt(record.repeats, `${path}.repeats`);
  if (repeats !== "" && repeats !== "Daily" && repeats !== "Weekly") {
    return invalid(`${path}.repeats`);
  }
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    homeworkName: stringAt(record.homeworkName, `${path}.homeworkName`),
    activityType: stringAt(record.activityType, `${path}.activityType`),
    valueSupportedName: optionalStringAt(
      record.valueSupportedName,
      `${path}.valueSupportedName`,
    ),
    activitySteps: stringAt(record.activitySteps, `${path}.activitySteps`),
    points: finiteNumberAt(record.points, `${path}.points`),
    coins: finiteNumberAt(record.coins, `${path}.coins`),
    completionStatus: stringAt(
      record.completionStatus,
      `${path}.completionStatus`,
    ),
    dueDate: nullableStringAt(record.dueDate, `${path}.dueDate`),
    isRecurring: booleanAt(record.isRecurring, `${path}.isRecurring`),
    overdue: booleanAt(record.overdue, `${path}.overdue`),
    repeats,
    assignedDate: stringAt(record.assignedDate, `${path}.assignedDate`),
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
  };
}

function currentHomeworkTemplateAt(
  value: unknown,
  path: string,
): CurrentHomeworkTemplateOption {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    name: stringAt(record.name, `${path}.name`),
    status: stringAt(record.status, `${path}.status`),
  };
}

const homeworkHistoryStatuses: readonly HomeworkHistoryStatus[] = [
  "Completed",
  "Completed with Modification",
  "Attempted",
  "Missed",
];

function homeworkHistoryFilterAt(
  value: unknown,
  path: string,
): HomeworkHistoryFilter {
  const parsed = stringAt(value, path);
  if (!homeworkHistoryFilters.includes(parsed as HomeworkHistoryFilter)) {
    return invalid(path);
  }
  return parsed as HomeworkHistoryFilter;
}

function caseloadEngagementPeriodAt(
  value: unknown,
  path: string,
): CaseloadEngagementPeriod {
  const parsed = stringAt(value, path);
  if (!caseloadEngagementPeriods.includes(parsed as CaseloadEngagementPeriod)) {
    return invalid(path);
  }
  return parsed as CaseloadEngagementPeriod;
}

function nullableNonNegativeIntegerAt(
  value: unknown,
  path: string,
): number | null {
  return value === null ? null : nonNegativeIntegerAt(value, path);
}

function caseloadMessageClientAt(
  value: unknown,
  path: string,
): CaseloadMessageClient {
  const record = objectAt(value, path);
  return {
    clientId: nonEmptyStringAt(record.clientId, `${path}.clientId`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    accessCode: stringAt(record.accessCode, `${path}.accessCode`),
    userMessageCount: nonNegativeIntegerAt(
      record.userMessageCount,
      `${path}.userMessageCount`,
    ),
  };
}

function caseloadHomeworkClientAt(
  value: unknown,
  path: string,
): CaseloadHomeworkClient {
  const record = objectAt(value, path);
  return {
    clientId: nonEmptyStringAt(record.clientId, `${path}.clientId`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    accessCode: stringAt(record.accessCode, `${path}.accessCode`),
    averageHomeworkSeconds: nullableNonNegativeIntegerAt(
      record.averageHomeworkSeconds,
      `${path}.averageHomeworkSeconds`,
    ),
    completedHomeworkCount: nonNegativeIntegerAt(
      record.completedHomeworkCount,
      `${path}.completedHomeworkCount`,
    ),
    completedHomeworkSeconds: nullableNonNegativeIntegerAt(
      record.completedHomeworkSeconds,
      `${path}.completedHomeworkSeconds`,
    ),
    assignmentsWithRecordedDuration: nonNegativeIntegerAt(
      record.assignmentsWithRecordedDuration,
      `${path}.assignmentsWithRecordedDuration`,
    ),
  };
}

function caseloadNoActivityClientAt(
  value: unknown,
  path: string,
): CaseloadNoActivityClient {
  const record = objectAt(value, path);
  return {
    clientId: nonEmptyStringAt(record.clientId, `${path}.clientId`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    accessCode: stringAt(record.accessCode, `${path}.accessCode`),
    status: stringAt(record.status, `${path}.status`),
    lastActiveDate: nullableStringAt(
      record.lastActiveDate,
      `${path}.lastActiveDate`,
    ),
    daysSinceActive: nullableNonNegativeIntegerAt(
      record.daysSinceActive,
      `${path}.daysSinceActive`,
    ),
  };
}

function caseloadEngagementReportAt(
  value: unknown,
  path: string,
): CaseloadEngagementReport {
  const record = objectAt(value, path);
  const summary = objectAt(record.summary, `${path}.summary`);
  if (!Array.isArray(record.topClientsByMessages)) {
    return invalid(`${path}.topClientsByMessages`);
  }
  if (!Array.isArray(record.topClientsByCompletedHomework)) {
    return invalid(`${path}.topClientsByCompletedHomework`);
  }
  if (!Array.isArray(record.clientsWithNoActivity)) {
    return invalid(`${path}.clientsWithNoActivity`);
  }

  return {
    period: caseloadEngagementPeriodAt(record.period, `${path}.period`),
    timezone: nonEmptyStringAt(record.timezone, `${path}.timezone`),
    asOfDate: calendarDateAt(record.asOfDate, `${path}.asOfDate`),
    windowStartDate: calendarDateAt(
      record.windowStartDate,
      `${path}.windowStartDate`,
    ),
    windowEndDate: calendarDateAt(
      record.windowEndDate,
      `${path}.windowEndDate`,
    ),
    generatedAt: nonEmptyStringAt(record.generatedAt, `${path}.generatedAt`),
    summary: {
      eligibleClientCount: nonNegativeIntegerAt(
        summary.eligibleClientCount,
        `${path}.summary.eligibleClientCount`,
      ),
      clientsWithMessageActivity: nonNegativeIntegerAt(
        summary.clientsWithMessageActivity,
        `${path}.summary.clientsWithMessageActivity`,
      ),
      clientsWithHomeworkActivity: nonNegativeIntegerAt(
        summary.clientsWithHomeworkActivity,
        `${path}.summary.clientsWithHomeworkActivity`,
      ),
      clientsWithNoActivity: nonNegativeIntegerAt(
        summary.clientsWithNoActivity,
        `${path}.summary.clientsWithNoActivity`,
      ),
    },
    topClientsByMessages: record.topClientsByMessages.map((client, index) =>
      caseloadMessageClientAt(client, `${path}.topClientsByMessages[${index}]`),
    ),
    topClientsByCompletedHomework: record.topClientsByCompletedHomework.map(
      (client, index) =>
        caseloadHomeworkClientAt(
          client,
          `${path}.topClientsByCompletedHomework[${index}]`,
        ),
    ),
    clientsWithNoActivity: record.clientsWithNoActivity.map((client, index) =>
      caseloadNoActivityClientAt(
        client,
        `${path}.clientsWithNoActivity[${index}]`,
      ),
    ),
  };
}

function homeworkHistoryStatusAt(
  value: unknown,
  path: string,
): HomeworkHistoryStatus {
  const parsed = stringAt(value, path);
  if (!homeworkHistoryStatuses.includes(parsed as HomeworkHistoryStatus)) {
    return invalid(path);
  }
  return parsed as HomeworkHistoryStatus;
}

function conversationReportUrlAt(value: unknown, path: string): string {
  const parsed = stringAt(value, path);
  if (!parsed) return "";

  try {
    const url = new URL(parsed);
    if (
      url.origin !== "https://assistant.educationforall.ai" ||
      url.pathname !== "/reports/conversation"
    ) {
      return invalid(path);
    }
  } catch {
    return invalid(path);
  }

  return parsed;
}

function homeworkHistoryAssignmentAt(
  value: unknown,
  path: string,
): HomeworkHistoryAssignment {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    homeworkName: stringAt(record.homeworkName, `${path}.homeworkName`),
    activityType: stringAt(record.activityType, `${path}.activityType`),
    valueSupportedName: optionalStringAt(
      record.valueSupportedName,
      `${path}.valueSupportedName`,
    ),
    activitySteps: stringAt(record.activitySteps, `${path}.activitySteps`),
    completionStatus: homeworkHistoryStatusAt(
      record.completionStatus,
      `${path}.completionStatus`,
    ),
    completedAt: nullableStringAt(record.completedAt, `${path}.completedAt`),
    dueDate: nullableStringAt(record.dueDate, `${path}.dueDate`),
    ...(record.overdue === undefined
      ? {}
      : { overdue: booleanAt(record.overdue, `${path}.overdue`) }),
    firstSuds: nullableNumberAt(record.firstSuds, `${path}.firstSuds`),
    secondSuds: nullableNumberAt(record.secondSuds, `${path}.secondSuds`),
    routineTime: stringAt(record.routineTime, `${path}.routineTime`),
    emailAlert: booleanAt(record.emailAlert, `${path}.emailAlert`),
    assignedDate: stringAt(record.assignedDate, `${path}.assignedDate`),
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    conversationReportUrl: conversationReportUrlAt(
      record.conversationReportUrl,
      `${path}.conversationReportUrl`,
    ),
  };
}

function homeworkCalendarStatusAt(
  value: unknown,
  path: string,
): HomeworkCalendarStatus {
  const parsed = stringAt(value, path);
  if (!homeworkCalendarStatuses.includes(parsed as HomeworkCalendarStatus)) {
    return invalid(path);
  }
  return parsed as HomeworkCalendarStatus;
}

function homeworkCalendarAssignmentAt(
  value: unknown,
  path: string,
): HomeworkCalendarAssignment {
  const record = objectAt(value, path);
  return {
    recordId: nonEmptyStringAt(record.recordId, `${path}.recordId`),
    activityName: stringAt(record.activityName, `${path}.activityName`),
    activityTypeId: stringAt(record.activityTypeId, `${path}.activityTypeId`),
    activityType: stringAt(record.activityType, `${path}.activityType`),
    completionStatus: stringAt(
      record.completionStatus,
      `${path}.completionStatus`,
    ),
    calendarStatus: homeworkCalendarStatusAt(
      record.calendarStatus,
      `${path}.calendarStatus`,
    ),
    calendarDate: calendarDateAt(record.calendarDate, `${path}.calendarDate`),
    dueDate: stringAt(record.dueDate, `${path}.dueDate`),
    completedAttemptedDate: stringAt(
      record.completedAttemptedDate,
      `${path}.completedAttemptedDate`,
    ),
    suds1: nullableNumberAt(record.suds1, `${path}.suds1`),
    suds2: nullableNumberAt(record.suds2, `${path}.suds2`),
    points: finiteNumberAt(record.points, `${path}.points`),
    coins: finiteNumberAt(record.coins, `${path}.coins`),
  };
}

function unscheduledHomeworkAssignmentAt(
  value: unknown,
  path: string,
): UnscheduledHomeworkAssignment {
  const record = objectAt(value, path);
  const completionStatus = stringAt(
    record.completionStatus,
    `${path}.completionStatus`,
  );
  if (completionStatus !== "Not Completed") {
    return invalid(`${path}.completionStatus`);
  }
  const dueDate = stringAt(record.dueDate, `${path}.dueDate`);
  if (dueDate !== "") return invalid(`${path}.dueDate`);

  return {
    recordId: nonEmptyStringAt(record.recordId, `${path}.recordId`),
    activityName: nonEmptyStringAt(record.activityName, `${path}.activityName`),
    activityTypeId: stringAt(record.activityTypeId, `${path}.activityTypeId`),
    activityType: stringAt(record.activityType, `${path}.activityType`),
    completionStatus,
    dueDate,
    points: finiteNumberAt(record.points, `${path}.points`),
    coins: finiteNumberAt(record.coins, `${path}.coins`),
  };
}

function dailyMoodCheckAt(value: unknown, path: string): DailyMoodCheck {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    recordedOn: calendarDateAt(record.recordedOn, `${path}.recordedOn`),
    moodRating: nullableRatingAt(record.moodRating, `${path}.moodRating`),
    ocdThoughtsObsessions: nullableRatingAt(
      record.ocdThoughtsObsessions,
      `${path}.ocdThoughtsObsessions`,
    ),
    ocdCompulsionsRituals: nullableRatingAt(
      record.ocdCompulsionsRituals,
      `${path}.ocdCompulsionsRituals`,
    ),
  };
}

function youthTopProblemRatingAt(
  value: unknown,
  path: string,
): YouthTopProblemRating {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    recordedOn: calendarDateAt(record.recordedOn, `${path}.recordedOn`),
    problem1Rating: nullableRatingAt(
      record.problem1Rating,
      `${path}.problem1Rating`,
    ),
    problem2Rating: nullableRatingAt(
      record.problem2Rating,
      `${path}.problem2Rating`,
    ),
    problem3Rating: nullableRatingAt(
      record.problem3Rating,
      `${path}.problem3Rating`,
    ),
  };
}

function expectancyPredictionResultAt(
  value: unknown,
  path: string,
): ExpectancyPredictionResult {
  const parsed = stringAt(value, path);
  if (
    !expectancyPredictionResults.includes(parsed as ExpectancyPredictionResult)
  ) {
    return invalid(path);
  }
  return parsed as ExpectancyPredictionResult;
}

function expectancyEntryAt(value: unknown, path: string): ExpectancyEntry {
  const record = objectAt(value, path);
  const createdAt = nonEmptyStringAt(record.createdAt, `${path}.createdAt`);
  if (Number.isNaN(Date.parse(createdAt))) return invalid(`${path}.createdAt`);

  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    patientId: nonEmptyStringAt(record.patientId, `${path}.patientId`),
    homeworkAssignmentId: stringAt(
      record.homeworkAssignmentId,
      `${path}.homeworkAssignmentId`,
    ),
    exposure: stringAt(record.exposure, `${path}.exposure`),
    obsession: stringAt(record.obsession, `${path}.obsession`),
    timeSinceExposure: stringAt(
      record.timeSinceExposure,
      `${path}.timeSinceExposure`,
    ),
    predictionResult: expectancyPredictionResultAt(
      record.predictionResult,
      `${path}.predictionResult`,
    ),
    whatILearned: stringAt(record.whatILearned, `${path}.whatILearned`),
    createdAt,
    createdByUser: stringAt(record.createdByUser, `${path}.createdByUser`),
  };
}

function homeworkAnalysisAt(
  value: unknown,
  path: string,
): PortalHomeworkAnalysis {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    analysis: stringAt(record.analysis, `${path}.analysis`),
    triggerSource: stringAt(record.triggerSource, `${path}.triggerSource`),
    createdAt: nonEmptyStringAt(record.createdAt, `${path}.createdAt`),
  };
}

function activityRegistryItemAt(
  value: unknown,
  path: string,
): PortalActivityRegistryItem {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    activityKey: nonEmptyStringAt(record.activityKey, `${path}.activityKey`),
    label: stringAt(record.label, `${path}.label`),
    description: stringAt(record.description, `${path}.description`),
    buddyType: stringAt(record.buddyType, `${path}.buddyType`),
    buddyOrder: nullableNumberAt(record.buddyOrder, `${path}.buddyOrder`),
    htmlFileName: stringAt(record.htmlFileName, `${path}.htmlFileName`),
    enabled: booleanAt(record.enabled, `${path}.enabled`),
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: stringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

function lovOrderingModeAt(value: unknown, path: string): LovOrderingMode {
  const orderingMode = stringAt(value, path);
  if (orderingMode !== "fixed" && orderingMode !== "alphabetical") {
    return invalid(path);
  }
  return orderingMode;
}

function lovCatalogAt(value: unknown, path: string): LovCatalog {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    key: nonEmptyStringAt(record.key, `${path}.key`),
    name: nonEmptyStringAt(record.name, `${path}.name`),
    selectionType: nonEmptyStringAt(
      record.selectionType,
      `${path}.selectionType`,
    ),
    orderingMode: lovOrderingModeAt(
      record.orderingMode,
      `${path}.orderingMode`,
    ),
    storageProvider: nonEmptyStringAt(
      record.storageProvider,
      `${path}.storageProvider`,
    ),
    description: stringAt(record.description, `${path}.description`),
    sortOrder: integerAt(record.sortOrder, `${path}.sortOrder`),
    enabled: booleanAt(record.enabled, `${path}.enabled`),
    createdAt: nonEmptyStringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: nonEmptyStringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

function lovOptionAt(value: unknown, path: string): LovOption {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    key: nonEmptyStringAt(record.key, `${path}.key`),
    value: nonEmptyStringAt(record.value, `${path}.value`),
    name: nonEmptyStringAt(record.name, `${path}.name`),
    colorKey: stringAt(record.colorKey, `${path}.colorKey`),
    sortOrder: integerAt(record.sortOrder, `${path}.sortOrder`),
    enabled: booleanAt(record.enabled, `${path}.enabled`),
    isDefault: booleanAt(record.isDefault, `${path}.isDefault`),
    collection: nullableStringAt(record.collection, `${path}.collection`),
    assetPath: nullableStringAt(record.assetPath, `${path}.assetPath`),
    createdAt: nonEmptyStringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: nonEmptyStringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

const portalFormFieldTypes: readonly PortalFormFieldType[] = [
  "text",
  "textarea",
  "integer",
  "number",
  "boolean",
  "lov",
  "relation",
  "date",
  "datetime",
  "email",
  "url",
  "attachment",
];

function formFieldTypeAt(value: unknown, path: string): PortalFormFieldType {
  const fieldType = stringAt(value, path);
  if (!portalFormFieldTypes.includes(fieldType as PortalFormFieldType)) {
    return invalid(path);
  }
  return fieldType as PortalFormFieldType;
}

function lovCatalogWithOptionsAt(
  value: unknown,
  path: string,
): LovCatalogWithOptions {
  const record = objectAt(value, path);
  if (!Array.isArray(record.options)) return invalid(`${path}.options`);
  return {
    ...lovCatalogAt(record, path),
    options: record.options.map((option, index) =>
      lovOptionAt(option, `${path}.options[${index}]`),
    ),
  };
}

function recordFormFieldAt(
  value: unknown,
  path: string,
): PortalRecordFormField {
  const record = objectAt(value, path);
  const fieldType = formFieldTypeAt(record.fieldType, `${path}.fieldType`);
  const catalog =
    record.catalog === null
      ? null
      : lovCatalogWithOptionsAt(record.catalog, `${path}.catalog`);
  const lovCatalogKey = nullableStringAt(
    record.lovCatalogKey,
    `${path}.lovCatalogKey`,
  );
  const relationSourceKey = nullableStringAt(
    record.relationSourceKey,
    `${path}.relationSourceKey`,
  );

  if (fieldType === "lov" && (!lovCatalogKey || !catalog)) {
    return invalid(`${path}.catalog`);
  }
  if (fieldType === "relation" && (!relationSourceKey || catalog)) {
    return invalid(`${path}.relationSourceKey`);
  }
  if (fieldType !== "lov" && catalog) return invalid(`${path}.catalog`);

  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    recordType: nonEmptyStringAt(record.recordType, `${path}.recordType`),
    fieldKey: nonEmptyStringAt(record.fieldKey, `${path}.fieldKey`),
    label: nonEmptyStringAt(record.label, `${path}.label`),
    fieldType,
    lovCatalogKey,
    relationSourceKey,
    displayOrder: integerAt(record.displayOrder, `${path}.displayOrder`),
    enabled: booleanAt(record.enabled, `${path}.enabled`),
    visibleOnCreate: booleanAt(
      record.visibleOnCreate,
      `${path}.visibleOnCreate`,
    ),
    visibleOnEdit: booleanAt(record.visibleOnEdit, `${path}.visibleOnEdit`),
    editableOnCreate: booleanAt(
      record.editableOnCreate,
      `${path}.editableOnCreate`,
    ),
    editableOnEdit: booleanAt(record.editableOnEdit, `${path}.editableOnEdit`),
    required: booleanAt(record.required, `${path}.required`),
    defaultValue:
      record.defaultValue === undefined
        ? invalid(`${path}.defaultValue`)
        : record.defaultValue,
    minValue: nullableNumberAt(record.minValue, `${path}.minValue`),
    maxValue: nullableNumberAt(record.maxValue, `${path}.maxValue`),
    helpText: nullableStringAt(record.helpText, `${path}.helpText`),
    createdAt: nullableStringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: nullableStringAt(record.updatedAt, `${path}.updatedAt`),
    catalog,
  };
}

function relationOptionAt(value: unknown, path: string): PortalRelationOption {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    value: nonEmptyStringAt(record.value, `${path}.value`),
    name: nonEmptyStringAt(record.name, `${path}.name`),
    enabled: booleanAt(record.enabled, `${path}.enabled`),
    status: stringAt(record.status, `${path}.status`),
  };
}

function clinicAt(value: unknown, path: string): AdminClinic {
  const record = objectAt(value, path);
  const therapistCount = finiteNumberAt(
    record.therapistCount,
    `${path}.therapistCount`,
  );
  if (!Number.isInteger(therapistCount) || therapistCount < 0) {
    return invalid(`${path}.therapistCount`);
  }

  const therapistIds = stringArrayAt(
    record.therapistIds,
    `${path}.therapistIds`,
  ).map((therapistId, index) =>
    nonEmptyStringAt(therapistId, `${path}.therapistIds[${index}]`),
  );

  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    clinicName: stringAt(record.clinicName, `${path}.clinicName`),
    status: stringAt(record.status, `${path}.status`),
    therapistCount,
    therapistIds,
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: stringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

function activityImageUrlAt(value: unknown, path: string): string {
  const parsed = stringAt(value, path);
  if (!parsed) return "";

  try {
    const url = new URL(parsed);
    const isApprovedPublicObject =
      url.protocol === "https:" &&
      !url.username &&
      !url.password &&
      url.hostname.endsWith(".supabase.co") &&
      url.pathname.startsWith("/storage/v1/object/public/efa-uploads/");
    if (!isApprovedPublicObject) return invalid(path);
  } catch {
    return invalid(path);
  }

  return parsed;
}

function activityImageAt(value: unknown, path: string): PortalActivityImage {
  const record = objectAt(value, path);
  const sortOrder = finiteNumberAt(record.sortOrder, `${path}.sortOrder`);
  if (!Number.isInteger(sortOrder) || sortOrder < 0) {
    return invalid(`${path}.sortOrder`);
  }

  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    filename: stringAt(record.filename, `${path}.filename`),
    url: activityImageUrlAt(record.url, `${path}.url`),
    storagePath: stringAt(record.storagePath, `${path}.storagePath`),
    mimeType: stringAt(record.mimeType, `${path}.mimeType`),
    sizeBytes: nullableNumberAt(record.sizeBytes, `${path}.sizeBytes`),
    sortOrder,
  };
}

function activityTemplateSummaryAt(
  value: unknown,
  path: string,
): PortalActivityTemplateSummary {
  const record = objectAt(value, path);
  const updatedAt = record.updatedAt ?? record.updated_at;
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    name: stringAt(record.name, `${path}.name`),
    activityType: stringAt(record.activityType, `${path}.activityType`),
    activitySteps: stringAt(record.activitySteps, `${path}.activitySteps`),
    coachingPrompts: stringAt(
      record.coachingPrompts,
      `${path}.coachingPrompts`,
    ),
    alternative: stringAt(record.alternative, `${path}.alternative`),
    points: finiteNumberAt(record.points, `${path}.points`),
    coins: finiteNumberAt(record.coins, `${path}.coins`),
    nonExposureHomework: booleanAt(
      record.nonExposureHomework,
      `${path}.nonExposureHomework`,
    ),
    status: stringAt(record.status, `${path}.status`),
    updatedAt:
      updatedAt === undefined || updatedAt === null
        ? null
        : stringAt(updatedAt, `${path}.updatedAt`),
  };
}

function activityTemplateStatusAt(
  value: unknown,
  path: string,
): ActivityTemplateStatus {
  const parsed = stringAt(value, path);
  if (parsed !== "On" && parsed !== "Off") return invalid(path);
  return parsed;
}

function activityTypeAt(value: unknown, path: string): PortalActivityType {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    key: nonEmptyStringAt(record.key, `${path}.key`),
    name: nonEmptyStringAt(record.name, `${path}.name`),
    colorKey: nonEmptyStringAt(record.colorKey, `${path}.colorKey`),
    sortOrder: integerAt(record.sortOrder, `${path}.sortOrder`),
    enabled: booleanAt(record.enabled, `${path}.enabled`),
  };
}

function activityTemplateRecordAt(
  value: unknown,
  path: string,
): PortalActivityTemplateRecord {
  const record = objectAt(value, path);
  return {
    ...activityTemplateSummaryAt(record, path),
    description: stringAt(record.description, `${path}.description`),
    activityTypeId: nonEmptyStringAt(
      record.activityTypeId,
      `${path}.activityTypeId`,
    ),
    status: activityTemplateStatusAt(record.status, `${path}.status`),
    protected: booleanAt(record.protected, `${path}.protected`),
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: stringAt(record.updatedAt, `${path}.updatedAt`),
  };
}

function activityTemplateDetailAt(
  value: unknown,
  path: string,
): PortalActivityTemplateDetail {
  const record = objectAt(value, path);
  if (!Array.isArray(record.activityImages)) {
    return invalid(`${path}.activityImages`);
  }
  return {
    ...activityTemplateRecordAt(record, path),
    activityImages: record.activityImages.map((image, index) =>
      activityImageAt(image, `${path}.activityImages[${index}]`),
    ),
  };
}

function homeworkActivitySummaryAt(
  value: unknown,
  path: string,
): PortalHomeworkActivitySummary {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    patientId: nonEmptyStringAt(record.patientId, `${path}.patientId`),
    accessCode: stringAt(record.accessCode, `${path}.accessCode`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    patientStatus: stringAt(record.patientStatus, `${path}.patientStatus`),
    activityTemplateId: stringAt(
      record.activityTemplateId,
      `${path}.activityTemplateId`,
    ),
    homeworkName: stringAt(record.homeworkName, `${path}.homeworkName`),
    activityType: stringAt(record.activityType, `${path}.activityType`),
    activitySteps: stringAt(record.activitySteps, `${path}.activitySteps`),
    completionStatus: stringAt(
      record.completionStatus,
      `${path}.completionStatus`,
    ),
    dueDate: nullableStringAt(record.dueDate, `${path}.dueDate`),
    completedAt: nullableStringAt(record.completedAt, `${path}.completedAt`),
    assignedDate: stringAt(record.assignedDate, `${path}.assignedDate`),
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: stringAt(record.updatedAt, `${path}.updatedAt`),
    points: finiteNumberAt(record.points, `${path}.points`),
    coins: finiteNumberAt(record.coins, `${path}.coins`),
    nonExposureHomework: booleanAt(
      record.nonExposureHomework,
      `${path}.nonExposureHomework`,
    ),
    firstSuds: nullableNumberAt(record.firstSuds, `${path}.firstSuds`),
    secondSuds: nullableNumberAt(record.secondSuds, `${path}.secondSuds`),
    copingSkills: stringAt(record.copingSkills, `${path}.copingSkills`),
    altered: stringAt(record.altered, `${path}.altered`),
  };
}

function homeworkActivitiesListAssignmentAt(
  value: unknown,
  path: string,
): PortalHomeworkActivitiesListAssignment {
  const record = objectAt(value, path);
  return {
    ...homeworkActivitySummaryAt(record, path),
    routineTime: stringAt(record.routineTime, `${path}.routineTime`),
    emailAlert: booleanAt(record.emailAlert, `${path}.emailAlert`),
    valueSupportedName: stringAt(
      record.valueSupportedName,
      `${path}.valueSupportedName`,
    ),
    conversationReportUrl: conversationReportUrlAt(
      record.conversationReportUrl,
      `${path}.conversationReportUrl`,
    ),
  };
}

function homeworkDetailAt(value: unknown, path: string): PortalHomeworkDetail {
  const record = objectAt(value, path);
  if (!Array.isArray(record.activityImages)) {
    return invalid(`${path}.activityImages`);
  }
  if (!Array.isArray(record.clientUploads)) {
    return invalid(`${path}.clientUploads`);
  }
  if (!Array.isArray(record.repeatOn)) return invalid(`${path}.repeatOn`);
  const repeats = stringAt(record.repeats, `${path}.repeats`);
  if (repeats !== "" && repeats !== "Daily" && repeats !== "Weekly") {
    return invalid(`${path}.repeats`);
  }
  const completionStatus = stringAt(
    record.completionStatus,
    `${path}.completionStatus`,
  );
  if (
    !homeworkCompletionStatuses.includes(
      completionStatus as HomeworkCompletionStatus,
    )
  ) {
    return invalid(`${path}.completionStatus`);
  }
  const repeatOn = record.repeatOn.map((entry, index) => {
    const weekday = stringAt(entry, `${path}.repeatOn[${index}]`);
    if (!weekdays.includes(weekday as Weekday)) {
      return invalid(`${path}.repeatOn[${index}]`);
    }
    return weekday as Weekday;
  });
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    homeworkAssignmentId: nonEmptyStringAt(
      record.homeworkAssignmentId,
      `${path}.homeworkAssignmentId`,
    ),
    activityTemplateId: nonEmptyStringAt(
      record.activityTemplateId,
      `${path}.activityTemplateId`,
    ),
    homeworkName: stringAt(record.homeworkName, `${path}.homeworkName`),
    activityTypeId: nonEmptyStringAt(
      record.activityTypeId,
      `${path}.activityTypeId`,
    ),
    activityType: stringAt(record.activityType, `${path}.activityType`),
    valueSupportedId: stringAt(
      record.valueSupportedId,
      `${path}.valueSupportedId`,
    ),
    nonExposureHomework: booleanAt(
      record.nonExposureHomework,
      `${path}.nonExposureHomework`,
    ),
    activitySteps: stringAt(record.activitySteps, `${path}.activitySteps`),
    alternativeSteps: stringAt(
      record.alternativeSteps,
      `${path}.alternativeSteps`,
    ),
    alternative: stringAt(record.alternative, `${path}.alternative`),
    coachingPrompts: stringAt(
      record.coachingPrompts,
      `${path}.coachingPrompts`,
    ),
    activityImages: record.activityImages.map((image, index) =>
      activityImageAt(image, `${path}.activityImages[${index}]`),
    ),
    points: finiteNumberAt(record.points, `${path}.points`),
    coins: finiteNumberAt(record.coins, `${path}.coins`),
    assignedDate: stringAt(record.assignedDate, `${path}.assignedDate`),
    dueDate: stringAt(record.dueDate, `${path}.dueDate`),
    isRecurring: booleanAt(record.isRecurring, `${path}.isRecurring`),
    repeatsUi: stringAt(record.repeatsUi, `${path}.repeatsUi`),
    repeats,
    repeatOn,
    recurrenceEndDate: nullableStringAt(
      record.recurrenceEndDate,
      `${path}.recurrenceEndDate`,
    ),
    completionStatus: completionStatus as HomeworkCompletionStatus,
    completedAt: nullableStringAt(record.completedAt, `${path}.completedAt`),
    completedDate: nullableStringAt(
      record.completedDate,
      `${path}.completedDate`,
    ),
    summary: stringAt(record.summary, `${path}.summary`),
    firstSuds: numberOrBlankAt(record.firstSuds, `${path}.firstSuds`),
    secondSuds: numberOrBlankAt(record.secondSuds, `${path}.secondSuds`),
    sentimentAnalysis: stringAt(
      record.sentimentAnalysis,
      `${path}.sentimentAnalysis`,
    ),
    copingSkills: stringAt(record.copingSkills, `${path}.copingSkills`),
    altered: stringAt(record.altered, `${path}.altered`),
    routineTime: stringAt(record.routineTime, `${path}.routineTime`),
    clientUploads: record.clientUploads.map((image, index) =>
      activityImageAt(image, `${path}.clientUploads[${index}]`),
    ),
    createdAt: stringAt(record.createdAt, `${path}.createdAt`),
    updatedAt: stringAt(record.updatedAt, `${path}.updatedAt`),
    overdue: booleanAt(record.overdue, `${path}.overdue`),
    emailAlert: booleanAt(record.emailAlert, `${path}.emailAlert`),
    conversationReportUrl: conversationReportUrlAt(
      record.conversationReportUrl,
      `${path}.conversationReportUrl`,
    ),
  };
}

function mutationHomeworkAt(
  value: unknown,
  path: string,
): PortalMutationHomework {
  const record = objectAt(value, path);
  return { id: nonEmptyStringAt(record.id, `${path}.id`) };
}

function nullableMutationHomeworkAt(
  value: unknown,
  path: string,
): PortalMutationHomework | null {
  return value === null ? null : mutationHomeworkAt(value, path);
}

function mutationErrorAt(record: JsonObject, path: string): string | undefined {
  return record.error === undefined
    ? undefined
    : stringAt(record.error, `${path}.error`);
}

const errorCodes: readonly ClinicianPortalErrorCode[] = [
  "INVALID_REQUEST",
  "INVALID_CLIENT_CREATE_REQUEST",
  "INVALID_CLIENT_UPDATE_REQUEST",
  "REQUIRED_FIELD_MISSING",
  "INVALID_LOV_VALUE",
  "DISABLED_LOV_VALUE",
  "INVALID_FIELD_TYPE",
  "INVALID_INTEGER",
  "VALUE_BELOW_MINIMUM",
  "VALUE_ABOVE_MAXIMUM",
  "INVALID_HIGH_SUDS_THRESHOLD",
  "INVALID_POINTS",
  "INVALID_COINS",
  "NO_CLIENT_FIELDS_PROVIDED",
  "FIELD_NOT_EDITABLE",
  "CLINIC_NOT_AVAILABLE",
  "INVALID_NICKNAME",
  "INVALID_STATUS",
  "INVALID_SUDS_INPUT_STYLE",
  "INVALID_COPING_STRATEGIES",
  "INVALID_FUN_ACTIVITIES",
  "INVALID_PATIENT_UPDATE",
  "INVALID_DATA_REQUEST",
  "INVALID_RANK_LEVEL_ID",
  "RANK_LEVEL_NOT_FOUND",
  "RANK_LEVEL_DISABLED",
  "INVALID_THRESHOLD_POINTS",
  "NO_RANK_LEVEL_RULE_FIELDS_PROVIDED",
  "DUPLICATE_CLIENT_RANK_LEVEL_RULE",
  "INVALID_COPING_SKILL_ID",
  "COPING_SKILL_NOT_FOUND",
  "INVALID_COPING_STRATEGY_OPTION_ID",
  "COPING_STRATEGY_OPTION_NOT_FOUND",
  "COPING_STRATEGY_OPTION_DISABLED",
  "INVALID_GUIDE_STEPS",
  "NO_COPING_SKILL_FIELDS_PROVIDED",
  "DUPLICATE_COPING_SKILL",
  "DUPLICATE_CLIENT_COPING_SKILL",
  "DUPLICATE_LOV_OPTION",
  "DUPLICATE_CLINIC",
  "INVALID_CLINIC_NAME",
  "THERAPIST_REQUIRED",
  "THERAPIST_NOT_FOUND",
  "DUPLICATE_THERAPIST",
  "INVALID_THERAPIST_NAME",
  "INVALID_EMAIL",
  "INVALID_ROLE",
  "CLINIC_NOT_FOUND",
  "ADMIN_REQUIRED",
  "FORBIDDEN",
  "NOT_AUTHORIZED",
  "NOT_FOUND",
  "TIMEOUT",
  "UPSTREAM_ERROR",
];

function failureAt(record: JsonObject): ClinicianPortalApiFailure {
  if (record.data !== null) return invalid("data");
  const error = objectAt(record.error, "error");
  const code = stringAt(error.code, "error.code");
  if (!errorCodes.includes(code as ClinicianPortalErrorCode)) {
    return invalid("error.code");
  }
  const operation = stringAt(record.operation, "operation");
  if (
    operation !== "" &&
    !portalOperations.includes(operation as PortalOperation)
  ) {
    return invalid("operation");
  }
  return {
    apiVersion: "1",
    operation: operation as PortalOperation | "",
    data: null,
    error: {
      code: code as ClinicianPortalErrorCode,
      message: stringAt(error.message, "error.message"),
      retryable: booleanAt(error.retryable, "error.retryable"),
    },
  };
}

function envelopeRecordAt(value: unknown): JsonObject {
  const record = objectAt(value, "response");
  if (record.apiVersion !== "1") return invalid("apiVersion");
  return record;
}

function parseTablePreferencesEnvelope<
  TOperation extends
    | "portal.getTablePreferences"
    | "portal.saveTablePreferences",
>(
  value: unknown,
  operation: TOperation,
): ClinicianPortalApiEnvelope<TablePreferencesData, TOperation> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== operation) return invalid("operation");

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");

  const tableKey = portalTableKeyAt(data.tableKey, "data.tableKey");
  const preference =
    data.preference === null
      ? null
      : tablePreferenceAt(data.preference, "data.preference");
  if (preference && preference.tableKey !== tableKey) {
    return invalid("data.preference.tableKey");
  }

  const parsedData: TablePreferencesData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation,
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    tableKey,
    configured: booleanAt(data.configured, "data.configured"),
    preference,
    ...(operation === "portal.saveTablePreferences"
      ? { saved: booleanAt(data.saved, "data.saved") }
      : {}),
  };

  if (parsedData.found && parsedData.authorized && !parsedData.therapist) {
    return invalid("data.authorizedTablePreferences");
  }
  if (parsedData.configured !== Boolean(parsedData.preference)) {
    return invalid("data.configured");
  }

  return {
    apiVersion: "1",
    operation,
    data: parsedData,
    error: null,
  };
}

export function parseGetTablePreferencesEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  TablePreferencesData,
  "portal.getTablePreferences"
> {
  return parseTablePreferencesEnvelope(value, "portal.getTablePreferences");
}

export function parseSaveTablePreferencesEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  TablePreferencesData,
  "portal.saveTablePreferences"
> {
  return parseTablePreferencesEnvelope(value, "portal.saveTablePreferences");
}

export function parseGetMyClientsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<MyClientsPageData, "portal.getMyClients"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getMyClients") return invalid("operation");

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getMyClients") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.patients)) return invalid("data.patients");

  const parsedData: MyClientsPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    operation: "portal.getMyClients",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patients: data.patients.map((patient, index) =>
      patientAt(patient, `data.patients[${index}]`),
    ),
  };

  if (parsedData.found && !parsedData.therapist) {
    return invalid("data.therapist");
  }

  return {
    apiVersion: "1",
    operation: "portal.getMyClients",
    data: parsedData,
    error: null,
  };
}

const clinicianAssistantLinkPages: readonly ClinicianAssistantLinkPage[] = [
  "client-profile",
  "client-homework",
  "client-insights",
  "homework-detail",
  "report",
  "supervisor-team",
  "supervisor-team-client",
  "supervisor-team-homework",
  "supervisor-team-reports",
];

function clinicianAssistantEvidenceAt(
  value: unknown,
  path: string,
): ClinicianAssistantEvidence {
  const record = objectAt(value, path);
  const parsedValue = record.value;
  if (
    parsedValue !== undefined &&
    parsedValue !== null &&
    typeof parsedValue !== "string" &&
    typeof parsedValue !== "number"
  ) {
    return invalid(`${path}.value`);
  }
  if (typeof parsedValue === "number" && !Number.isFinite(parsedValue)) {
    return invalid(`${path}.value`);
  }
  return {
    type: nonEmptyStringAt(record.type, `${path}.type`),
    label: nonEmptyStringAt(record.label, `${path}.label`),
    ...(parsedValue === undefined ? {} : { value: parsedValue }),
    ...(record.occurredAt === undefined
      ? {}
      : {
          occurredAt:
            record.occurredAt === null
              ? null
              : timestampAt(record.occurredAt, `${path}.occurredAt`),
        }),
    ...(record.patientId === undefined
      ? {}
      : { patientId: nonEmptyStringAt(record.patientId, `${path}.patientId`) }),
  };
}

function clinicianAssistantLinkAt(
  value: unknown,
  path: string,
): ClinicianAssistantLink | null {
  const record = objectAt(value, path);
  if (typeof record.page !== "string") return null;
  const page = record.page;
  if (
    !clinicianAssistantLinkPages.includes(page as ClinicianAssistantLinkPage)
  ) {
    return null;
  }
  return {
    label: nonEmptyStringAt(record.label, `${path}.label`),
    page: page as ClinicianAssistantLinkPage,
    ...(record.patientId === undefined
      ? {}
      : { patientId: nonEmptyStringAt(record.patientId, `${path}.patientId`) }),
    ...(record.homeworkAssignmentId === undefined
      ? {}
      : {
          homeworkAssignmentId: nonEmptyStringAt(
            record.homeworkAssignmentId,
            `${path}.homeworkAssignmentId`,
          ),
        }),
    ...(record.reportKey === undefined
      ? {}
      : { reportKey: nonEmptyStringAt(record.reportKey, `${path}.reportKey`) }),
  };
}

export function parseAskClinicianAssistantEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  ClinicianAssistantResult,
  "portal.askClinicianAssistant"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.askClinicianAssistant") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (
    data.operation !== undefined &&
    data.operation !== "portal.askClinicianAssistant"
  ) {
    return invalid("data.operation");
  }
  if (data.db !== undefined && data.db !== "supabase") {
    return invalid("data.db");
  }

  let parsedData: ClinicianAssistantResult;
  if (data.needsClarification === true) {
    if (!Array.isArray(data.choices) || data.choices.length === 0) {
      return invalid("data.choices");
    }
    parsedData = {
      success: true,
      needsClarification: true,
      message: nonEmptyStringAt(data.message, "data.message"),
      choices: data.choices.map((choice, index) => {
        const choiceRecord = objectAt(choice, `data.choices[${index}]`);
        return {
          patientId: nonEmptyStringAt(
            choiceRecord.patientId,
            `data.choices[${index}].patientId`,
          ),
          label: nonEmptyStringAt(
            choiceRecord.label,
            `data.choices[${index}].label`,
          ),
        };
      }),
    } satisfies ClinicianAssistantClarification;
  } else {
    if (data.authorized !== true) return invalid("data.authorized");
    const resolvedContext =
      data.resolvedContext === undefined
        ? undefined
        : objectAt(data.resolvedContext, "data.resolvedContext");
    if (data.evidence !== undefined && !Array.isArray(data.evidence)) {
      return invalid("data.evidence");
    }
    if (data.links !== undefined && !Array.isArray(data.links)) {
      return invalid("data.links");
    }
    parsedData = {
      success: true,
      authorized: true,
      answer: nonEmptyStringAt(data.answer, "data.answer"),
      generatedAt: timestampAt(data.generatedAt, "data.generatedAt"),
      ...(resolvedContext === undefined
        ? {}
        : {
            resolvedContext: {
              ...(resolvedContext.patientId === undefined
                ? {}
                : {
                    patientId: nonEmptyStringAt(
                      resolvedContext.patientId,
                      "data.resolvedContext.patientId",
                    ),
                  }),
              ...(resolvedContext.patientNickname === undefined
                ? {}
                : {
                    patientNickname: nonEmptyStringAt(
                      resolvedContext.patientNickname,
                      "data.resolvedContext.patientNickname",
                    ),
                  }),
            },
          }),
      ...(data.evidence === undefined
        ? {}
        : {
            evidence: data.evidence.map((entry, index) =>
              clinicianAssistantEvidenceAt(entry, `data.evidence[${index}]`),
            ),
          }),
      ...(data.links === undefined
        ? {}
        : {
            links: data.links
              .map((link, index) =>
                clinicianAssistantLinkAt(link, `data.links[${index}]`),
              )
              .filter((link): link is ClinicianAssistantLink => link !== null),
          }),
    };
  }

  return {
    apiVersion: "1",
    operation: "portal.askClinicianAssistant",
    data: parsedData,
    error: null,
  };
}

function supervisorMembershipRoleAt(
  value: unknown,
  path: string,
): SupervisorMembershipRole {
  const role = stringAt(value, path);
  if (role !== "therapist" && role !== "supervisor") return invalid(path);
  return role;
}

function supervisorTeamMembershipAt(
  value: unknown,
  path: string,
): SupervisorTeamMembership {
  const record = objectAt(value, path);
  return {
    clinicId: nonEmptyStringAt(record.clinicId, `${path}.clinicId`),
    clinicName: nonEmptyStringAt(record.clinicName, `${path}.clinicName`),
    membershipRole: supervisorMembershipRoleAt(
      record.membershipRole,
      `${path}.membershipRole`,
    ),
  };
}

function supervisorTeamMemberAt(
  value: unknown,
  path: string,
): SupervisorTeamMember {
  const record = objectAt(value, path);
  if (!Array.isArray(record.memberships)) {
    return invalid(`${path}.memberships`);
  }
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    therapistName: nonEmptyStringAt(
      record.therapistName,
      `${path}.therapistName`,
    ),
    email: stringAt(record.email, `${path}.email`),
    clinicianCode:
      record.clinicianCode === undefined
        ? ""
        : stringAt(record.clinicianCode, `${path}.clinicianCode`),
    accountRole: nonEmptyStringAt(record.accountRole, `${path}.accountRole`),
    status: stringAt(record.status, `${path}.status`),
    isCurrentUser: booleanAt(record.isCurrentUser, `${path}.isCurrentUser`),
    memberships: record.memberships.map((membership, index) =>
      supervisorTeamMembershipAt(membership, `${path}.memberships[${index}]`),
    ),
  };
}

function supervisorClinicSummaryAt(
  value: unknown,
  path: string,
): SupervisorClinicSummary {
  const record = objectAt(value, path);
  const summary: SupervisorClinicSummary = {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    clinicName: nonEmptyStringAt(record.clinicName, `${path}.clinicName`),
    status: stringAt(record.status, `${path}.status`),
  };
  if (record.teamMemberCount !== undefined) {
    summary.teamMemberCount = nonNegativeIntegerAt(
      record.teamMemberCount,
      `${path}.teamMemberCount`,
    );
  }
  if (record.supervisorCount !== undefined) {
    summary.supervisorCount = nonNegativeIntegerAt(
      record.supervisorCount,
      `${path}.supervisorCount`,
    );
  }
  if (record.therapistCount !== undefined) {
    summary.therapistCount = nonNegativeIntegerAt(
      record.therapistCount,
      `${path}.therapistCount`,
    );
  }
  if (
    summary.teamMemberCount !== undefined &&
    summary.supervisorCount !== undefined &&
    summary.therapistCount !== undefined &&
    summary.teamMemberCount !== summary.supervisorCount + summary.therapistCount
  ) {
    return invalid(`${path}.teamMemberCount`);
  }
  return summary;
}

function supervisorClinicOptionAt(
  value: unknown,
  path: string,
): SupervisorClinicOption {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    clinicName: nonEmptyStringAt(record.clinicName, `${path}.clinicName`),
    status: stringAt(record.status, `${path}.status`),
  };
}

function clientRecordAccessAt(
  value: unknown,
  path: string,
): ClientRecordAccess {
  const record = objectAt(value, path);
  const scope = stringAt(record.scope, `${path}.scope`);
  if (scope !== "assigned" && scope !== "team") return invalid(`${path}.scope`);
  return { scope, readOnly: booleanAt(record.readOnly, `${path}.readOnly`) };
}

function clientRecordAccessFields(data: JsonObject): {
  access?: ClientRecordAccess;
} {
  return data.access == null
    ? {}
    : { access: clientRecordAccessAt(data.access, "data.access") };
}

function assignedCliniciansAt(value: unknown, path: string) {
  if (!Array.isArray(value)) return invalid(path);
  return value.map((entry, index) => {
    const entryPath = `${path}[${index}]`;
    const record = objectAt(entry, entryPath);
    return {
      id: nonEmptyStringAt(record.id, `${entryPath}.id`),
      therapistName: nonEmptyStringAt(
        record.therapistName,
        `${entryPath}.therapistName`,
      ),
    };
  });
}

function supervisorClinicOptionsAt(
  data: Record<string, unknown>,
): SupervisorClinicOption[] {
  const rawOptions = data.clinicOptions ?? data.clinics;
  if (!Array.isArray(rawOptions)) return invalid("data.clinicOptions");
  const options = rawOptions.map((clinic, index) =>
    supervisorClinicOptionAt(clinic, `data.clinicOptions[${index}]`),
  );
  if (new Set(options.map((clinic) => clinic.id)).size !== options.length) {
    return invalid("data.clinicOptions");
  }
  return options;
}

function supervisorTeamClientAt(
  value: unknown,
  path: string,
): SupervisorTeamClient {
  const record = objectAt(value, path);
  if (!Array.isArray(record.assignedTherapists)) {
    return invalid(`${path}.assignedTherapists`);
  }

  const assignedTherapists = record.assignedTherapists.map(
    (assignedTherapist, index) => {
      const assignedPath = `${path}.assignedTherapists[${index}]`;
      const assignedRecord = objectAt(assignedTherapist, assignedPath);
      return {
        id: nonEmptyStringAt(assignedRecord.id, `${assignedPath}.id`),
        therapistName: nonEmptyStringAt(
          assignedRecord.therapistName,
          `${assignedPath}.therapistName`,
        ),
      };
    },
  );

  if (
    new Set(assignedTherapists.map((assignedTherapist) => assignedTherapist.id))
      .size !== assignedTherapists.length
  ) {
    return invalid(`${path}.assignedTherapists`);
  }

  return {
    ...patientAt(record, path),
    clinicName: stringAt(record.clinicName, `${path}.clinicName`),
    assignedTherapists,
  };
}

export function parseGetSupervisorTeamOverviewEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SupervisorTeamOverviewData,
  "portal.supervisor.getTeamOverview"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.supervisor.getTeamOverview") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.supervisor.getTeamOverview") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.clinics)) return invalid("data.clinics");
  if (!Array.isArray(data.teamMembers)) return invalid("data.teamMembers");

  const summaryRecord = objectAt(data.summary, "data.summary");
  const parsedData: SupervisorTeamOverviewData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.supervisor.getTeamOverview",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    clinicOptions: supervisorClinicOptionsAt(data),
    clinics: data.clinics.map((clinic, index) =>
      supervisorClinicSummaryAt(clinic, `data.clinics[${index}]`),
    ),
    teamMembers: data.teamMembers.map((teamMember, index) =>
      supervisorTeamMemberAt(teamMember, `data.teamMembers[${index}]`),
    ),
    summary: {
      clinicCount: nonNegativeIntegerAt(
        summaryRecord.clinicCount,
        "data.summary.clinicCount",
      ),
      teamMemberCount: nonNegativeIntegerAt(
        summaryRecord.teamMemberCount,
        "data.summary.teamMemberCount",
      ),
      supervisorCount: nonNegativeIntegerAt(
        summaryRecord.supervisorCount,
        "data.summary.supervisorCount",
      ),
      therapistCount: nonNegativeIntegerAt(
        summaryRecord.therapistCount,
        "data.summary.therapistCount",
      ),
    },
  };

  if (parsedData.summary.clinicCount !== parsedData.clinics.length) {
    return invalid("data.summary.clinicCount");
  }
  if (parsedData.summary.teamMemberCount !== parsedData.teamMembers.length) {
    return invalid("data.summary.teamMemberCount");
  }
  if (
    parsedData.summary.teamMemberCount !==
    parsedData.summary.supervisorCount + parsedData.summary.therapistCount
  ) {
    return invalid("data.summary.teamMemberCount");
  }
  if (
    parsedData.authorized &&
    (!parsedData.found ||
      parsedData.therapist?.role !== "supervisor" ||
      parsedData.teamMembers.filter((member) => member.isCurrentUser).length !==
        1 ||
      parsedData.teamMembers.find((member) => member.isCurrentUser)?.id !==
        parsedData.therapist.id)
  ) {
    return invalid("data.authorized");
  }

  return {
    apiVersion: "1",
    operation: "portal.supervisor.getTeamOverview",
    data: parsedData,
    error: null,
  };
}

export function parseGetSupervisorTeamClientsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SupervisorTeamClientsData,
  "portal.supervisor.getTeamClients"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.supervisor.getTeamClients") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.supervisor.getTeamClients") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.clinics)) return invalid("data.clinics");
  if (!Array.isArray(data.teamMembers)) return invalid("data.teamMembers");
  if (!Array.isArray(data.clients)) return invalid("data.clients");

  const clinics = data.clinics.map((clinic, index) =>
    supervisorClinicSummaryAt(clinic, `data.clinics[${index}]`),
  );
  const teamMembers = data.teamMembers.map((teamMember, index) =>
    supervisorTeamMemberAt(teamMember, `data.teamMembers[${index}]`),
  );
  const clinicById = new Map(clinics.map((clinic) => [clinic.id, clinic]));
  const teamMemberById = new Map(
    teamMembers.map((teamMember) => [teamMember.id, teamMember]),
  );

  const clients = data.clients.map((client, clientIndex) => {
    const path = `data.clients[${clientIndex}]`;
    const record = objectAt(client, path);
    if (!Array.isArray(record.assignedTherapists)) {
      return invalid(`${path}.assignedTherapists`);
    }

    const parsedPatient = patientAt(record, path);
    const clinicName = stringAt(record.clinicName, `${path}.clinicName`);
    const assignedTherapists = record.assignedTherapists.map(
      (assignedTherapist, assignedTherapistIndex) => {
        const assignedPath = `${path}.assignedTherapists[${assignedTherapistIndex}]`;
        const assignedRecord = objectAt(assignedTherapist, assignedPath);
        const id = nonEmptyStringAt(assignedRecord.id, `${assignedPath}.id`);
        const therapistName = nonEmptyStringAt(
          assignedRecord.therapistName,
          `${assignedPath}.therapistName`,
        );
        const matchingMember = teamMemberById.get(id);
        if (!matchingMember || matchingMember.therapistName !== therapistName) {
          return invalid(`${assignedPath}.id`);
        }
        return { id, therapistName };
      },
    );

    const clinic = clinicById.get(parsedPatient.clinicId);
    if (!clinic || (clinicName && clinic.clinicName !== clinicName)) {
      return invalid(`${path}.clinicId`);
    }
    if (
      new Set(
        assignedTherapists.map((assignedTherapist) => assignedTherapist.id),
      ).size !== assignedTherapists.length
    ) {
      return invalid(`${path}.assignedTherapists`);
    }

    return {
      ...parsedPatient,
      clinicName,
      assignedTherapists,
    };
  });

  const summaryRecord = objectAt(data.summary, "data.summary");
  const parsedData: SupervisorTeamClientsData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.supervisor.getTeamClients",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    clinicOptions: supervisorClinicOptionsAt(data),
    clinics,
    teamMembers,
    clients,
    summary: {
      clientCount: nonNegativeIntegerAt(
        summaryRecord.clientCount,
        "data.summary.clientCount",
      ),
      activatedClientCount: nonNegativeIntegerAt(
        summaryRecord.activatedClientCount,
        "data.summary.activatedClientCount",
      ),
    },
  };

  if (
    new Set(parsedData.clients.map((client) => client.id)).size !==
    parsedData.clients.length
  ) {
    return invalid("data.clients");
  }
  if (parsedData.summary.clientCount !== parsedData.clients.length) {
    return invalid("data.summary.clientCount");
  }
  if (
    parsedData.summary.activatedClientCount !==
    parsedData.clients.filter(
      (client) => client.status.trim().toLowerCase() === "activated",
    ).length
  ) {
    return invalid("data.summary.activatedClientCount");
  }
  if (
    parsedData.authorized &&
    (!parsedData.found ||
      parsedData.therapist?.role !== "supervisor" ||
      parsedData.teamMembers.filter((member) => member.isCurrentUser).length !==
        1 ||
      parsedData.teamMembers.find((member) => member.isCurrentUser)?.id !==
        parsedData.therapist.id)
  ) {
    return invalid("data.authorized");
  }

  return {
    apiVersion: "1",
    operation: "portal.supervisor.getTeamClients",
    data: parsedData,
    error: null,
  };
}

export function parseGetSupervisorTeamClientDetailEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SupervisorTeamClientDetailData,
  "portal.supervisor.getTeamClientDetail"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.supervisor.getTeamClientDetail") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.supervisor.getTeamClientDetail") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");

  const parsedData: SupervisorTeamClientDetailData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.supervisor.getTeamClientDetail",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    client:
      data.client === null
        ? null
        : supervisorTeamClientAt(data.client, "data.client"),
    clinic:
      data.clinic == null
        ? null
        : (() => {
            const clinic = objectAt(data.clinic, "data.clinic");
            return {
              id: nonEmptyStringAt(clinic.id, "data.clinic.id"),
              clinicName: nonEmptyStringAt(
                clinic.clinicName,
                "data.clinic.clinicName",
              ),
            };
          })(),
    assignedClinicians: assignedCliniciansAt(
      data.assignedClinicians ?? [],
      "data.assignedClinicians",
    ),
    access:
      data.access == null
        ? null
        : clientRecordAccessAt(data.access, "data.access"),
  };

  if (
    parsedData.authorized &&
    (!parsedData.found ||
      parsedData.therapist?.role !== "supervisor" ||
      !parsedData.client ||
      parsedData.access?.scope !== "team" ||
      parsedData.access.readOnly !== true)
  ) {
    return invalid("data.authorized");
  }

  return {
    apiVersion: "1",
    operation: "portal.supervisor.getTeamClientDetail",
    data: parsedData,
    error: null,
  };
}

export function parseGetSupervisorTeamHomeworkEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SupervisorTeamHomeworkData,
  "portal.supervisor.getTeamHomework"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.supervisor.getTeamHomework") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.supervisor.getTeamHomework") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.clinics)) return invalid("data.clinics");
  if (!Array.isArray(data.teamMembers)) return invalid("data.teamMembers");
  if (!Array.isArray(data.clients)) return invalid("data.clients");
  if (!Array.isArray(data.assignments)) return invalid("data.assignments");

  const clinics = data.clinics.map((clinic, index) =>
    supervisorClinicSummaryAt(clinic, `data.clinics[${index}]`),
  );
  const teamMembers = data.teamMembers.map((teamMember, index) =>
    supervisorTeamMemberAt(teamMember, `data.teamMembers[${index}]`),
  );
  const clinicById = new Map(clinics.map((clinic) => [clinic.id, clinic]));
  const teamMemberById = new Map(
    teamMembers.map((teamMember) => [teamMember.id, teamMember]),
  );

  const clients = data.clients.map((client, clientIndex) => {
    const path = `data.clients[${clientIndex}]`;
    const clientRecord = objectAt(client, path);
    if (!Array.isArray(clientRecord.assignedTherapists)) {
      return invalid(`${path}.assignedTherapists`);
    }

    const parsedPatient = patientAt(clientRecord, path);
    const clinicName = stringAt(clientRecord.clinicName, `${path}.clinicName`);
    const assignedTherapists = clientRecord.assignedTherapists.map(
      (assignedTherapist, assignedTherapistIndex) => {
        const assignedPath = `${path}.assignedTherapists[${assignedTherapistIndex}]`;
        const assignedRecord = objectAt(assignedTherapist, assignedPath);
        const id = nonEmptyStringAt(assignedRecord.id, `${assignedPath}.id`);
        const therapistName = nonEmptyStringAt(
          assignedRecord.therapistName,
          `${assignedPath}.therapistName`,
        );
        const matchingMember = teamMemberById.get(id);
        if (!matchingMember || matchingMember.therapistName !== therapistName) {
          return invalid(`${assignedPath}.id`);
        }
        return { id, therapistName };
      },
    );

    const clinic = clinicById.get(parsedPatient.clinicId);
    if (!clinic || (clinicName && clinic.clinicName !== clinicName)) {
      return invalid(`${path}.clinicId`);
    }

    return {
      ...parsedPatient,
      clinicName,
      assignedTherapists,
    };
  });
  const clientById = new Map(clients.map((client) => [client.id, client]));

  const assignments = data.assignments.map((assignment, assignmentIndex) => {
    const path = `data.assignments[${assignmentIndex}]`;
    const assignmentRecord = objectAt(assignment, path);
    const parsedAssignment = homeworkActivitySummaryAt(assignmentRecord, path);
    const clinicId = nonEmptyStringAt(
      assignmentRecord.clinicId,
      `${path}.clinicId`,
    );
    const clinicName = stringAt(
      assignmentRecord.clinicName,
      `${path}.clinicName`,
    );
    const clinicianId = nonEmptyStringAt(
      assignmentRecord.clinicianId,
      `${path}.clinicianId`,
    );
    const clinicianName = nonEmptyStringAt(
      assignmentRecord.clinicianName,
      `${path}.clinicianName`,
    );
    const client = clientById.get(parsedAssignment.patientId);
    const clinic = clinicById.get(clinicId);
    const clinician = teamMemberById.get(clinicianId);

    if (
      !client ||
      client.clinicId !== clinicId ||
      client.accessCode !== parsedAssignment.accessCode ||
      client.nickname !== parsedAssignment.nickname ||
      client.status !== parsedAssignment.patientStatus
    ) {
      return invalid(`${path}.patientId`);
    }
    if (!clinic || (clinicName && clinic.clinicName !== clinicName)) {
      return invalid(`${path}.clinicId`);
    }
    if (!clinician || clinician.therapistName !== clinicianName) {
      return invalid(`${path}.clinicianId`);
    }

    return {
      ...parsedAssignment,
      clinicId,
      clinicName,
      clinicianId,
      clinicianName,
    };
  });

  const summaryRecord = objectAt(data.summary, "data.summary");
  const parsedData: SupervisorTeamHomeworkData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.supervisor.getTeamHomework",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    clinicOptions: supervisorClinicOptionsAt(data),
    clinics,
    teamMembers,
    clients,
    assignments,
    summary: {
      assignmentCount: nonNegativeIntegerAt(
        summaryRecord.assignmentCount,
        "data.summary.assignmentCount",
      ),
      notCompletedCount: nonNegativeIntegerAt(
        summaryRecord.notCompletedCount,
        "data.summary.notCompletedCount",
      ),
    },
  };

  if (new Set(clients.map((client) => client.id)).size !== clients.length) {
    return invalid("data.clients");
  }
  if (
    new Set(assignments.map((assignment) => assignment.id)).size !==
    assignments.length
  ) {
    return invalid("data.assignments");
  }
  if (parsedData.summary.assignmentCount !== assignments.length) {
    return invalid("data.summary.assignmentCount");
  }
  if (
    parsedData.summary.notCompletedCount !==
    assignments.filter(
      (assignment) =>
        assignment.completionStatus.trim().toLowerCase() === "not completed",
    ).length
  ) {
    return invalid("data.summary.notCompletedCount");
  }
  if (
    parsedData.authorized &&
    (!parsedData.found ||
      parsedData.therapist?.role !== "supervisor" ||
      parsedData.teamMembers.filter((member) => member.isCurrentUser).length !==
        1 ||
      parsedData.teamMembers.find((member) => member.isCurrentUser)?.id !==
        parsedData.therapist.id)
  ) {
    return invalid("data.authorized");
  }

  return {
    apiVersion: "1",
    operation: "portal.supervisor.getTeamHomework",
    data: parsedData,
    error: null,
  };
}

export function parseGetSupervisorTeamHomeworkDetailEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SupervisorTeamHomeworkDetailData,
  "portal.supervisor.getTeamHomeworkDetail"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.supervisor.getTeamHomeworkDetail") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.supervisor.getTeamHomeworkDetail") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");

  const parsedData: SupervisorTeamHomeworkDetailData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.supervisor.getTeamHomeworkDetail",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    client:
      data.client === null
        ? null
        : supervisorTeamClientAt(data.client, "data.client"),
    clinician:
      data.clinician === null
        ? null
        : supervisorTeamMemberAt(data.clinician, "data.clinician"),
    homework:
      data.homework === null
        ? null
        : homeworkDetailAt(data.homework, "data.homework"),
  };

  if (
    parsedData.authorized &&
    (!parsedData.found ||
      parsedData.therapist?.role !== "supervisor" ||
      !parsedData.client ||
      !parsedData.clinician ||
      !parsedData.homework ||
      !parsedData.clinician.memberships.some(
        (membership) => membership.clinicId === parsedData.client?.clinicId,
      ))
  ) {
    return invalid("data.authorized");
  }

  return {
    apiVersion: "1",
    operation: "portal.supervisor.getTeamHomeworkDetail",
    data: parsedData,
    error: null,
  };
}

export function parseGetSupervisorTeamReportsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SupervisorTeamReportsData,
  "portal.supervisor.getTeamReports"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.supervisor.getTeamReports") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.supervisor.getTeamReports") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.timezone !== "America/Los_Angeles") {
    return invalid("data.timezone");
  }
  if (!Array.isArray(data.assignments)) return invalid("data.assignments");
  if (!Array.isArray(data.messageEvents)) return invalid("data.messageEvents");

  const clientData = parseGetSupervisorTeamClientsEnvelope({
    apiVersion: "1",
    operation: "portal.supervisor.getTeamClients",
    data: {
      ...data,
      operation: "portal.supervisor.getTeamClients",
      summary: {
        clientCount: Array.isArray(data.clients) ? data.clients.length : 0,
        activatedClientCount: Array.isArray(data.clients)
          ? data.clients.filter((client) => {
              const clientRecord = objectAt(client, "data.clients[]");
              return (
                stringAt(clientRecord.status, "data.clients[].status")
                  .trim()
                  .toLowerCase() === "activated"
              );
            }).length
          : 0,
      },
    },
    error: null,
  }).data;

  const teamMemberIds = new Set(
    clientData.teamMembers.map((member) => member.id),
  );
  const clientById = new Map(
    clientData.clients.map((client) => [client.id, client]),
  );

  const assignments = data.assignments.map((assignment, index) => {
    const path = `data.assignments[${index}]`;
    const assignmentRecord = objectAt(assignment, path);
    if (!Array.isArray(assignmentRecord.assignedTherapistIds)) {
      return invalid(`${path}.assignedTherapistIds`);
    }
    const patientId = nonEmptyStringAt(
      assignmentRecord.patientId,
      `${path}.patientId`,
    );
    const clinicId = nonEmptyStringAt(
      assignmentRecord.clinicId,
      `${path}.clinicId`,
    );
    const assignedTherapistIds = assignmentRecord.assignedTherapistIds.map(
      (id, therapistIndex) =>
        nonEmptyStringAt(id, `${path}.assignedTherapistIds[${therapistIndex}]`),
    );
    const client = clientById.get(patientId);
    if (
      !client ||
      client.clinicId !== clinicId ||
      assignedTherapistIds.some((id) => !teamMemberIds.has(id)) ||
      assignedTherapistIds.some(
        (id) =>
          !client.assignedTherapists.some((therapist) => therapist.id === id),
      )
    ) {
      return invalid(`${path}.patientId`);
    }

    const assignedAt = timestampAt(
      assignmentRecord.assignedAt,
      `${path}.assignedAt`,
    );
    const completedAt = nullableStringAt(
      assignmentRecord.completedAt,
      `${path}.completedAt`,
    );
    if (completedAt !== null && Number.isNaN(Date.parse(completedAt))) {
      return invalid(`${path}.completedAt`);
    }

    return {
      id: nonEmptyStringAt(assignmentRecord.id, `${path}.id`),
      patientId,
      clinicId,
      assignedTherapistIds,
      createdByTherapistId: nullableStringAt(
        assignmentRecord.createdByTherapistId,
        `${path}.createdByTherapistId`,
      ),
      activityTemplateId: nullableStringAt(
        assignmentRecord.activityTemplateId,
        `${path}.activityTemplateId`,
      ),
      homeworkName: stringAt(
        assignmentRecord.homeworkName,
        `${path}.homeworkName`,
      ),
      completionStatus: stringAt(
        assignmentRecord.completionStatus,
        `${path}.completionStatus`,
      ),
      dueDate: nullableStringAt(assignmentRecord.dueDate, `${path}.dueDate`),
      assignedAt,
      completedAt,
      firstSuds: nullableNumberAt(
        assignmentRecord.firstSuds,
        `${path}.firstSuds`,
      ),
      secondSuds: nullableNumberAt(
        assignmentRecord.secondSuds,
        `${path}.secondSuds`,
      ),
      copingSkills: stringAt(
        assignmentRecord.copingSkills,
        `${path}.copingSkills`,
      ),
      altered: stringAt(assignmentRecord.altered, `${path}.altered`),
      routineTime: stringAt(
        assignmentRecord.routineTime,
        `${path}.routineTime`,
      ),
      deviceType: stringAt(assignmentRecord.deviceType, `${path}.deviceType`),
      valueSupportedId: nullableStringAt(
        assignmentRecord.valueSupportedId,
        `${path}.valueSupportedId`,
      ),
    };
  });

  const messageEvents = data.messageEvents.map((event, index) => {
    const path = `data.messageEvents[${index}]`;
    const eventRecord = objectAt(event, path);
    const patientId = nonEmptyStringAt(
      eventRecord.patientId,
      `${path}.patientId`,
    );
    if (!clientById.has(patientId)) return invalid(`${path}.patientId`);
    return {
      patientId,
      occurredAt: timestampAt(eventRecord.occurredAt, `${path}.occurredAt`),
    };
  });

  const summaryRecord = objectAt(data.summary, "data.summary");
  const summary = {
    assignmentCount: nonNegativeIntegerAt(
      summaryRecord.assignmentCount,
      "data.summary.assignmentCount",
    ),
    userMessageCount: nonNegativeIntegerAt(
      summaryRecord.userMessageCount,
      "data.summary.userMessageCount",
    ),
  };
  if (
    summary.assignmentCount !== assignments.length ||
    summary.userMessageCount !== messageEvents.length ||
    new Set(assignments.map((assignment) => assignment.id)).size !==
      assignments.length
  ) {
    return invalid("data.summary");
  }

  return {
    apiVersion: "1",
    operation: "portal.supervisor.getTeamReports",
    data: {
      success: true,
      found: clientData.found,
      authorized: clientData.authorized,
      operation: "portal.supervisor.getTeamReports",
      db: "supabase",
      therapist: clientData.therapist,
      timezone: "America/Los_Angeles",
      generatedAt: timestampAt(data.generatedAt, "data.generatedAt"),
      clinicOptions: clientData.clinicOptions,
      clinics: clientData.clinics,
      teamMembers: clientData.teamMembers,
      clients: clientData.clients,
      assignments,
      messageEvents,
      summary,
    },
    error: null,
  };
}

export function parseGetClientEnvelope(
  value: unknown,
  requireHomeworkEngagement = true,
): ClinicianPortalApiEnvelope<ClientProfilePageData, "portal.getClient"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getClient") return invalid("operation");

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getClient") return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");

  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const patient = nullablePatientAt(data.patient, "data.patient");
  const homeworkEngagement =
    data.homeworkEngagement === undefined
      ? undefined
      : engagementAt(data.homeworkEngagement, "data.homeworkEngagement");

  if (
    found &&
    authorized &&
    (!therapist ||
      !patient ||
      (requireHomeworkEngagement && !homeworkEngagement))
  ) {
    return invalid("data.authorizedProfile");
  }

  return {
    apiVersion: "1",
    operation: "portal.getClient",
    data: {
      success: true,
      found,
      authorized,
      operation: "portal.getClient",
      db: "supabase",
      therapist,
      patient,
      ...(homeworkEngagement ? { homeworkEngagement } : {}),
      ...clientRecordAccessFields(data),
    },
    error: null,
  };
}

export function parseGetClientValuesEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<ClientValuesData, "portal.getClientValues"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getClientValues") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getClientValues") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.values)) return invalid("data.values");

  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const patient = nullablePatientAt(data.patient, "data.patient");
  const values = data.values.map((clientValue, index) =>
    clientValueAt(clientValue, `data.values[${index}]`),
  );

  if (found && authorized && (!therapist || !patient)) {
    return invalid("data.authorizedClientValues");
  }
  if (
    patient &&
    values.some((clientValue) => clientValue.patientId !== patient.id)
  ) {
    return invalid("data.values.patientId");
  }

  return {
    apiVersion: "1",
    operation: "portal.getClientValues",
    data: {
      success: true,
      found,
      authorized,
      operation: "portal.getClientValues",
      db: "supabase",
      therapist,
      patient,
      values,
      ...clientRecordAccessFields(data),
    },
    error: null,
  };
}

function percentageAt(value: unknown, path: string): number | null {
  if (value === null) return null;
  const parsed = finiteNumberAt(value, path);
  if (parsed < 0 || parsed > 100) return invalid(path);
  return parsed;
}

function valueEngagementClientAt(
  value: unknown,
  path: string,
): ValueEngagementClient {
  const record = objectAt(value, path);
  return {
    patientId: nonEmptyStringAt(record.patientId, `${path}.patientId`),
    accessCode: nonEmptyStringAt(record.accessCode, `${path}.accessCode`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
  };
}

function valueEngagementActivityOptionAt(
  value: unknown,
  path: string,
): ValueEngagementActivityOption {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    name: nonEmptyStringAt(record.name, `${path}.name`),
  };
}

function valueEngagementMetricAt(
  value: unknown,
  path: string,
): ValueEngagementMetric {
  const record = objectAt(value, path);
  const metric = {
    engagedCount: nonNegativeIntegerAt(
      record.engagedCount,
      `${path}.engagedCount`,
    ),
    sampleSize: nonNegativeIntegerAt(record.sampleSize, `${path}.sampleSize`),
    engagementRate: percentageAt(
      record.engagementRate,
      `${path}.engagementRate`,
    ),
  };
  if (metric.engagedCount > metric.sampleSize) {
    return invalid(`${path}.engagedCount`);
  }
  if (
    (metric.sampleSize === 0 && metric.engagementRate !== null) ||
    (metric.sampleSize > 0 && metric.engagementRate === null)
  ) {
    return invalid(`${path}.engagementRate`);
  }
  return metric;
}

function valueEngagementAssignmentAt(
  value: unknown,
  path: string,
): ValueEngagementAssignment {
  const record = objectAt(value, path);
  const completionStatus = stringAt(
    record.completionStatus,
    `${path}.completionStatus`,
  );
  if (
    completionStatus !== "Completed" &&
    completionStatus !== "Completed with Modification" &&
    completionStatus !== "Attempted" &&
    completionStatus !== "Missed"
  ) {
    return invalid(`${path}.completionStatus`);
  }

  const assignment: ValueEngagementAssignment = {
    assignmentId: nonEmptyStringAt(record.assignmentId, `${path}.assignmentId`),
    patientId: nonEmptyStringAt(record.patientId, `${path}.patientId`),
    accessCode: nonEmptyStringAt(record.accessCode, `${path}.accessCode`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    activityTemplateId: nullableStringAt(
      record.activityTemplateId,
      `${path}.activityTemplateId`,
    ),
    homeworkActivity: nonEmptyStringAt(
      record.homeworkActivity,
      `${path}.homeworkActivity`,
    ),
    valueLinked: booleanAt(record.valueLinked, `${path}.valueLinked`),
    valueSupportedId: nullableStringAt(
      record.valueSupportedId,
      `${path}.valueSupportedId`,
    ),
    valueSupportedName: stringAt(
      record.valueSupportedName,
      `${path}.valueSupportedName`,
    ),
    completionStatus,
    engaged: booleanAt(record.engaged, `${path}.engaged`),
    assignedAt: nonEmptyStringAt(record.assignedAt, `${path}.assignedAt`),
    completedAt: nullableStringAt(record.completedAt, `${path}.completedAt`),
  };

  if (assignment.valueLinked !== Boolean(assignment.valueSupportedId)) {
    return invalid(`${path}.valueLinked`);
  }
  const shouldBeEngaged =
    completionStatus === "Completed" ||
    completionStatus === "Completed with Modification";
  if (assignment.engaged !== shouldBeEngaged) {
    return invalid(`${path}.engaged`);
  }
  return assignment;
}

export function parseGetValueEngagementEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  ValueEngagementReportData,
  "portal.reports.getValueEngagement"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.reports.getValueEngagement") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.reports.getValueEngagement") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.report !== "valueEngagement") return invalid("data.report");
  if (!Array.isArray(data.activityOptions)) {
    return invalid("data.activityOptions");
  }
  if (!Array.isArray(data.assignments)) return invalid("data.assignments");

  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const client =
    data.client === null
      ? null
      : valueEngagementClientAt(data.client, "data.client");
  const filtersRecord = objectAt(data.filters, "data.filters");
  const filters = {
    patientId: nonEmptyStringAt(
      filtersRecord.patientId,
      "data.filters.patientId",
    ),
    accessCode: stringAt(filtersRecord.accessCode, "data.filters.accessCode"),
    activityTemplateId: nullableStringAt(
      filtersRecord.activityTemplateId,
      "data.filters.activityTemplateId",
    ),
    homeworkActivity: stringAt(
      filtersRecord.homeworkActivity,
      "data.filters.homeworkActivity",
    ),
  };
  const activityOptions = data.activityOptions.map((option, index) =>
    valueEngagementActivityOptionAt(option, `data.activityOptions[${index}]`),
  );
  const metricsRecord = objectAt(data.metrics, "data.metrics");
  const metrics = {
    totalSampleSize: nonNegativeIntegerAt(
      metricsRecord.totalSampleSize,
      "data.metrics.totalSampleSize",
    ),
    valueLinked: valueEngagementMetricAt(
      metricsRecord.valueLinked,
      "data.metrics.valueLinked",
    ),
    noValueLinked: valueEngagementMetricAt(
      metricsRecord.noValueLinked,
      "data.metrics.noValueLinked",
    ),
    differencePercentagePoints: nullableNumberAt(
      metricsRecord.differencePercentagePoints,
      "data.metrics.differencePercentagePoints",
    ),
  };
  if (
    metrics.differencePercentagePoints !== null &&
    Math.abs(metrics.differencePercentagePoints) > 100
  ) {
    return invalid("data.metrics.differencePercentagePoints");
  }
  const assignments = data.assignments.map((assignment, index) =>
    valueEngagementAssignmentAt(assignment, `data.assignments[${index}]`),
  );

  if (found && authorized && (!therapist || !client)) {
    return invalid("data.authorizedValueEngagement");
  }
  if (client) {
    if (
      filters.patientId !== client.patientId ||
      filters.accessCode !== client.accessCode ||
      assignments.some(
        (assignment) =>
          assignment.patientId !== client.patientId ||
          assignment.accessCode !== client.accessCode,
      )
    ) {
      return invalid("data.clientScope");
    }
  }
  if (
    filters.activityTemplateId &&
    assignments.some(
      (assignment) =>
        assignment.activityTemplateId !== filters.activityTemplateId,
    )
  ) {
    return invalid("data.filters.activityTemplateId");
  }
  if (
    metrics.totalSampleSize !== assignments.length ||
    metrics.totalSampleSize !==
      metrics.valueLinked.sampleSize + metrics.noValueLinked.sampleSize
  ) {
    return invalid("data.metrics.totalSampleSize");
  }

  return {
    apiVersion: "1",
    operation: "portal.reports.getValueEngagement",
    data: {
      success: true,
      found,
      authorized,
      operation: "portal.reports.getValueEngagement",
      db: "supabase",
      therapist,
      client,
      report: "valueEngagement",
      generatedAt: nonEmptyStringAt(data.generatedAt, "data.generatedAt"),
      filters,
      activityOptions,
      metrics,
      assignments,
    },
    error: null,
  };
}

function homeworkOverviewPeriodAt(
  value: unknown,
  path: string,
): HomeworkOverviewPeriod {
  const parsed = stringAt(value, path);
  if (!homeworkOverviewPeriods.includes(parsed as HomeworkOverviewPeriod)) {
    return invalid(path);
  }
  return parsed as HomeworkOverviewPeriod;
}

function homeworkOverviewClientOptionAt(
  value: unknown,
  path: string,
): HomeworkOverviewClientOption {
  const record = objectAt(value, path);
  const rawStatus =
    record.status ?? record.patientStatus ?? record.patient_status;
  return {
    patientId: nonEmptyStringAt(record.patientId, `${path}.patientId`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    accessCode: nonEmptyStringAt(record.accessCode, `${path}.accessCode`),
    // Older report responses did not include status. Treat those already-
    // authorized legacy options as activated during the backend rollout.
    status:
      rawStatus === undefined
        ? "Activated"
        : stringAt(rawStatus, `${path}.status`),
  };
}

function homeworkOverviewSummaryAt(
  value: unknown,
  path: string,
): HomeworkOverviewSummary {
  const record = objectAt(value, path);
  const summary = {
    assigned: nonNegativeIntegerAt(record.assigned, `${path}.assigned`),
    completed: nonNegativeIntegerAt(record.completed, `${path}.completed`),
    open: nonNegativeIntegerAt(record.open, `${path}.open`),
    overdue: nonNegativeIntegerAt(record.overdue, `${path}.overdue`),
    completionRate: percentageAt(
      record.completionRate,
      `${path}.completionRate`,
    ),
    selfInitiated: nonNegativeIntegerAt(
      record.selfInitiated,
      `${path}.selfInitiated`,
    ),
  };

  if (
    summary.completed + summary.open !== summary.assigned ||
    summary.overdue > summary.open ||
    summary.selfInitiated > summary.assigned
  ) {
    return invalid(path);
  }
  if (
    (summary.assigned === 0 && summary.completionRate !== null) ||
    (summary.assigned > 0 && summary.completionRate === null)
  ) {
    return invalid(`${path}.completionRate`);
  }
  return summary;
}

function nullableNonNegativeNumberAt(
  value: unknown,
  path: string,
): number | null {
  const parsed = nullableNumberAt(value, path);
  if (parsed !== null && parsed < 0) return invalid(path);
  return parsed;
}

function homeworkOverviewClinicalMetricsAt(
  value: unknown,
  path: string,
): HomeworkOverviewClinicalMetrics {
  const record = objectAt(value, path);
  const metrics: HomeworkOverviewClinicalMetrics = {
    copingSkillAppliedCount: nonNegativeIntegerAt(
      record.copingSkillAppliedCount,
      `${path}.copingSkillAppliedCount`,
    ),
    copingSkillAppliedDenominator: nonNegativeIntegerAt(
      record.copingSkillAppliedDenominator,
      `${path}.copingSkillAppliedDenominator`,
    ),
    copingSkillAppliedRate: percentageAt(
      record.copingSkillAppliedRate,
      `${path}.copingSkillAppliedRate`,
    ),
    alteredRoutineCount: nonNegativeIntegerAt(
      record.alteredRoutineCount,
      `${path}.alteredRoutineCount`,
    ),
    alteredRoutineDenominator: nonNegativeIntegerAt(
      record.alteredRoutineDenominator,
      `${path}.alteredRoutineDenominator`,
    ),
    alteredRoutineRate: percentageAt(
      record.alteredRoutineRate,
      `${path}.alteredRoutineRate`,
    ),
    pairedSudsCount: nonNegativeIntegerAt(
      record.pairedSudsCount,
      `${path}.pairedSudsCount`,
    ),
    averagePreSuds: nullableNumberAt(
      record.averagePreSuds,
      `${path}.averagePreSuds`,
    ),
    averagePostSuds: nullableNumberAt(
      record.averagePostSuds,
      `${path}.averagePostSuds`,
    ),
    averageSudsChange: nullableNumberAt(
      record.averageSudsChange,
      `${path}.averageSudsChange`,
    ),
    routineTimeRecordedCount: nonNegativeIntegerAt(
      record.routineTimeRecordedCount,
      `${path}.routineTimeRecordedCount`,
    ),
    averageRoutineTime: nullableNonNegativeNumberAt(
      record.averageRoutineTime,
      `${path}.averageRoutineTime`,
    ),
    medianRoutineTime: nullableNonNegativeNumberAt(
      record.medianRoutineTime,
      `${path}.medianRoutineTime`,
    ),
    routineTimeUnit: stringAt(
      record.routineTimeUnit,
      `${path}.routineTimeUnit`,
    ) as "minutes",
  };

  if (metrics.routineTimeUnit !== "minutes") {
    return invalid(`${path}.routineTimeUnit`);
  }
  if (
    metrics.copingSkillAppliedCount > metrics.copingSkillAppliedDenominator ||
    metrics.alteredRoutineCount > metrics.alteredRoutineDenominator
  ) {
    return invalid(path);
  }
  for (const [denominator, rate, ratePath] of [
    [
      metrics.copingSkillAppliedDenominator,
      metrics.copingSkillAppliedRate,
      `${path}.copingSkillAppliedRate`,
    ],
    [
      metrics.alteredRoutineDenominator,
      metrics.alteredRoutineRate,
      `${path}.alteredRoutineRate`,
    ],
  ] as const) {
    if (
      (denominator === 0 && rate !== null) ||
      (denominator > 0 && rate === null)
    ) {
      return invalid(ratePath);
    }
  }
  const sudsValues = [metrics.averagePreSuds, metrics.averagePostSuds];
  if (
    sudsValues.some(
      (rating) => rating !== null && (rating < 0 || rating > 10),
    ) ||
    (metrics.averageSudsChange !== null &&
      (metrics.averageSudsChange < -10 || metrics.averageSudsChange > 10)) ||
    (metrics.pairedSudsCount === 0 &&
      [...sudsValues, metrics.averageSudsChange].some(
        (value) => value !== null,
      )) ||
    (metrics.pairedSudsCount > 0 &&
      [...sudsValues, metrics.averageSudsChange].some(
        (value) => value === null,
      ))
  ) {
    return invalid(`${path}.pairedSuds`);
  }
  if (
    (metrics.routineTimeRecordedCount === 0 &&
      (metrics.averageRoutineTime !== null ||
        metrics.medianRoutineTime !== null)) ||
    (metrics.routineTimeRecordedCount > 0 &&
      (metrics.averageRoutineTime === null ||
        metrics.medianRoutineTime === null))
  ) {
    return invalid(`${path}.routineTime`);
  }
  return metrics;
}

export function parseGetHomeworkOverviewEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  HomeworkOverviewReportData,
  "portal.reports.getHomeworkOverview"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.reports.getHomeworkOverview") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.reports.getHomeworkOverview") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.report !== "homeworkOverview") return invalid("data.report");
  if (data.timezone !== "America/Los_Angeles") {
    return invalid("data.timezone");
  }
  if (!Array.isArray(data.clientOptions)) return invalid("data.clientOptions");

  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const filtersRecord = objectAt(data.filters, "data.filters");
  const patientId = nullableStringAt(
    filtersRecord.patientId,
    "data.filters.patientId",
  );
  if (patientId !== null && !patientId.trim()) {
    return invalid("data.filters.patientId");
  }
  const filters = {
    patientId,
    period: homeworkOverviewPeriodAt(
      filtersRecord.period,
      "data.filters.period",
    ),
    startDate: calendarDateAt(
      filtersRecord.startDate,
      "data.filters.startDate",
    ),
    endDate: calendarDateAt(filtersRecord.endDate, "data.filters.endDate"),
    dateBasis: stringAt(
      filtersRecord.dateBasis,
      "data.filters.dateBasis",
    ) as "assigned",
  };
  if (filters.dateBasis !== "assigned" || filters.startDate > filters.endDate) {
    return invalid("data.filters");
  }

  const clientOptions = data.clientOptions.map((client, index) =>
    homeworkOverviewClientOptionAt(client, `data.clientOptions[${index}]`),
  );
  const summary = homeworkOverviewSummaryAt(data.summary, "data.summary");
  const clinicalMetrics = homeworkOverviewClinicalMetricsAt(
    data.clinicalMetrics,
    "data.clinicalMetrics",
  );
  if (
    clinicalMetrics.copingSkillAppliedDenominator !== summary.completed ||
    clinicalMetrics.alteredRoutineDenominator !== summary.completed
  ) {
    return invalid("data.clinicalMetrics.denominator");
  }
  if (found && authorized && !therapist) {
    return invalid("data.authorizedHomeworkOverview");
  }
  if (
    found &&
    authorized &&
    filters.patientId &&
    !clientOptions.some((client) => client.patientId === filters.patientId)
  ) {
    return invalid("data.filters.patientId");
  }

  return {
    apiVersion: "1",
    operation: "portal.reports.getHomeworkOverview",
    data: {
      success: true,
      found,
      authorized,
      operation: "portal.reports.getHomeworkOverview",
      db: "supabase",
      therapist,
      report: "homeworkOverview",
      generatedAt: nonEmptyStringAt(data.generatedAt, "data.generatedAt"),
      timezone: "America/Los_Angeles",
      asOfDate: calendarDateAt(data.asOfDate, "data.asOfDate"),
      filters,
      clientOptions,
      summary,
      clinicalMetrics,
    },
    error: null,
  };
}

function completionByDevicePeriodAt(
  value: unknown,
  path: string,
): CompletionByDevicePeriod {
  const parsed = stringAt(value, path);
  if (!completionByDevicePeriods.includes(parsed as CompletionByDevicePeriod)) {
    return invalid(path);
  }
  return parsed as CompletionByDevicePeriod;
}

function completionByDeviceClientOptionAt(
  value: unknown,
  path: string,
): CompletionByDeviceClientOption {
  const record = objectAt(value, path);
  const rawStatus =
    record.status ?? record.patientStatus ?? record.patient_status;
  return {
    patientId: nonEmptyStringAt(record.patientId, `${path}.patientId`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    accessCode: nonEmptyStringAt(record.accessCode, `${path}.accessCode`),
    // Older report responses did not include status. Treat those already-
    // authorized legacy options as activated during the backend rollout.
    status:
      rawStatus === undefined
        ? "Activated"
        : stringAt(rawStatus, `${path}.status`),
  };
}

function completionByDeviceActivityOptionAt(
  value: unknown,
  path: string,
): CompletionByDeviceActivityOption {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    name: nonEmptyStringAt(record.name, `${path}.name`),
  };
}

const completionByDeviceKeys: readonly CompletionByDeviceKey[] = [
  "desktop_laptop",
  "iphone",
  "android_phone",
  "ipad",
  "android_tablet",
  "unknown",
];

function completionByDeviceSummaryAt(
  value: unknown,
  path: string,
): CompletionByDeviceSummary {
  const record = objectAt(value, path);
  const summary = {
    completedAssignments: nonNegativeIntegerAt(
      record.completedAssignments,
      `${path}.completedAssignments`,
    ),
    knownDeviceAssignments: nonNegativeIntegerAt(
      record.knownDeviceAssignments,
      `${path}.knownDeviceAssignments`,
    ),
    unknownDeviceAssignments: nonNegativeIntegerAt(
      record.unknownDeviceAssignments,
      `${path}.unknownDeviceAssignments`,
    ),
  };
  if (
    summary.knownDeviceAssignments + summary.unknownDeviceAssignments !==
    summary.completedAssignments
  ) {
    return invalid(path);
  }
  return summary;
}

function completionByDeviceBreakdownItemAt(
  value: unknown,
  path: string,
): CompletionByDeviceBreakdownItem {
  const record = objectAt(value, path);
  const deviceKey = stringAt(record.deviceKey, `${path}.deviceKey`);
  if (!completionByDeviceKeys.includes(deviceKey as CompletionByDeviceKey)) {
    return invalid(`${path}.deviceKey`);
  }
  const percentage = percentageAt(record.percentage, `${path}.percentage`);
  if (percentage === null) return invalid(`${path}.percentage`);
  return {
    deviceKey: deviceKey as CompletionByDeviceKey,
    deviceLabel: nonEmptyStringAt(record.deviceLabel, `${path}.deviceLabel`),
    completedCount: nonNegativeIntegerAt(
      record.completedCount,
      `${path}.completedCount`,
    ),
    percentage,
  };
}

export function parseGetCompletionByDeviceEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CompletionByDeviceReportData,
  "portal.reports.getCompletionByDevice"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.reports.getCompletionByDevice") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.reports.getCompletionByDevice") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.report !== "completionByDevice") return invalid("data.report");
  if (data.timezone !== "America/Los_Angeles") {
    return invalid("data.timezone");
  }
  if (!Array.isArray(data.clientOptions)) return invalid("data.clientOptions");
  if (!Array.isArray(data.activityOptions)) {
    return invalid("data.activityOptions");
  }
  if (!Array.isArray(data.deviceBreakdown)) {
    return invalid("data.deviceBreakdown");
  }

  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const filtersRecord = objectAt(data.filters, "data.filters");
  const patientId = nullableStringAt(
    filtersRecord.patientId,
    "data.filters.patientId",
  );
  const activityTemplateId = nullableStringAt(
    filtersRecord.activityTemplateId,
    "data.filters.activityTemplateId",
  );
  if (patientId !== null && !patientId.trim()) {
    return invalid("data.filters.patientId");
  }
  if (activityTemplateId !== null && !activityTemplateId.trim()) {
    return invalid("data.filters.activityTemplateId");
  }
  const filters = {
    patientId,
    activityTemplateId,
    period: completionByDevicePeriodAt(
      filtersRecord.period,
      "data.filters.period",
    ),
    startDate: calendarDateAt(
      filtersRecord.startDate,
      "data.filters.startDate",
    ),
    endDate: calendarDateAt(filtersRecord.endDate, "data.filters.endDate"),
    dateBasis: stringAt(
      filtersRecord.dateBasis,
      "data.filters.dateBasis",
    ) as "completed",
  };
  if (
    filters.dateBasis !== "completed" ||
    filters.startDate > filters.endDate
  ) {
    return invalid("data.filters");
  }

  const clientOptions = data.clientOptions.map((client, index) =>
    completionByDeviceClientOptionAt(client, `data.clientOptions[${index}]`),
  );
  const activityOptions = data.activityOptions.map((activity, index) =>
    completionByDeviceActivityOptionAt(
      activity,
      `data.activityOptions[${index}]`,
    ),
  );
  const summary = completionByDeviceSummaryAt(data.summary, "data.summary");
  const deviceBreakdown = data.deviceBreakdown.map((item, index) =>
    completionByDeviceBreakdownItemAt(item, `data.deviceBreakdown[${index}]`),
  );
  const breakdownTotal = deviceBreakdown.reduce(
    (total, item) => total + item.completedCount,
    0,
  );
  const unknownTotal =
    deviceBreakdown.find((item) => item.deviceKey === "unknown")
      ?.completedCount ?? 0;
  if (
    breakdownTotal !== summary.completedAssignments ||
    unknownTotal !== summary.unknownDeviceAssignments ||
    new Set(deviceBreakdown.map((item) => item.deviceKey)).size !==
      deviceBreakdown.length
  ) {
    return invalid("data.deviceBreakdown");
  }
  if (found && authorized && !therapist) {
    return invalid("data.authorizedCompletionByDevice");
  }
  if (
    found &&
    authorized &&
    filters.patientId &&
    !clientOptions.some((client) => client.patientId === filters.patientId)
  ) {
    return invalid("data.filters.patientId");
  }

  return {
    apiVersion: "1",
    operation: "portal.reports.getCompletionByDevice",
    data: {
      success: true,
      found,
      authorized,
      operation: "portal.reports.getCompletionByDevice",
      db: "supabase",
      therapist,
      report: "completionByDevice",
      generatedAt: nonEmptyStringAt(data.generatedAt, "data.generatedAt"),
      timezone: "America/Los_Angeles",
      asOfDate: calendarDateAt(data.asOfDate, "data.asOfDate"),
      filters,
      clientOptions,
      activityOptions,
      summary,
      deviceBreakdown,
    },
    error: null,
  };
}

function timestampAt(value: unknown, path: string): string {
  const parsed = nonEmptyStringAt(value, path);
  if (Number.isNaN(Date.parse(parsed))) return invalid(path);
  return parsed;
}

function dashboardAttentionEventTypeAt(
  value: unknown,
  path: string,
): DashboardAttentionEventType {
  const record = objectAt(value, path);
  const parsed = {
    safetyEventType: nonEmptyStringAt(
      record.safetyEventType,
      `${path}.safetyEventType`,
    ),
    count: nonNegativeIntegerAt(record.count, `${path}.count`),
  };
  if (parsed.count < 1) return invalid(`${path}.count`);
  return parsed;
}

function dashboardAttentionSafetyClientAt(
  value: unknown,
  path: string,
): DashboardAttentionSafetyClient {
  const record = objectAt(value, path);
  if (!Array.isArray(record.eventTypes)) return invalid(`${path}.eventTypes`);
  const parsed = {
    clientId: nonEmptyStringAt(record.clientId, `${path}.clientId`),
    accessCode: nonEmptyStringAt(record.accessCode, `${path}.accessCode`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    safetyDetectionCount: nonNegativeIntegerAt(
      record.safetyDetectionCount,
      `${path}.safetyDetectionCount`,
    ),
    sessionsWithSafetyDetections: nonNegativeIntegerAt(
      record.sessionsWithSafetyDetections,
      `${path}.sessionsWithSafetyDetections`,
    ),
    lastSafetyEventAt: timestampAt(
      record.lastSafetyEventAt,
      `${path}.lastSafetyEventAt`,
    ),
    eventTypes: record.eventTypes.map((eventType, index) =>
      dashboardAttentionEventTypeAt(eventType, `${path}.eventTypes[${index}]`),
    ),
  };
  if (
    parsed.safetyDetectionCount < 1 ||
    parsed.sessionsWithSafetyDetections < 1 ||
    parsed.sessionsWithSafetyDetections > parsed.safetyDetectionCount ||
    parsed.eventTypes.reduce((total, item) => total + item.count, 0) >
      parsed.safetyDetectionCount
  ) {
    return invalid(path);
  }
  return parsed;
}

function dashboardAttentionInactiveClientAt(
  value: unknown,
  path: string,
): DashboardAttentionInactiveClient {
  const record = objectAt(value, path);
  const lastActiveDate = nullableStringAt(
    record.lastActiveDate,
    `${path}.lastActiveDate`,
  );
  const daysSinceActive =
    record.daysSinceActive === null
      ? null
      : nonNegativeIntegerAt(record.daysSinceActive, `${path}.daysSinceActive`);
  if ((lastActiveDate === null) !== (daysSinceActive === null)) {
    return invalid(path);
  }
  return {
    clientId: nonEmptyStringAt(record.clientId, `${path}.clientId`),
    accessCode: nonEmptyStringAt(record.accessCode, `${path}.accessCode`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    status: stringAt(record.status, `${path}.status`),
    lastActiveDate:
      lastActiveDate === null
        ? null
        : calendarDateAt(lastActiveDate, `${path}.lastActiveDate`),
    daysSinceActive,
  };
}

function dashboardAttentionEngagementStatusAt(
  value: unknown,
  path: string,
): DashboardAttentionEngagementStatus {
  const parsed = stringAt(value, path);
  if (
    !dashboardAttentionEngagementStatuses.includes(
      parsed as DashboardAttentionEngagementStatus,
    )
  ) {
    return invalid(path);
  }
  return parsed as DashboardAttentionEngagementStatus;
}

function dashboardAttentionEngagementClientAt(
  value: unknown,
  path: string,
): DashboardAttentionEngagementClient {
  const record = objectAt(value, path);
  const lastAssistantUseAt =
    record.lastAssistantUseAt === null
      ? null
      : timestampAt(record.lastAssistantUseAt, `${path}.lastAssistantUseAt`);
  const daysSinceAssistantUse = nullableNonNegativeIntegerAt(
    record.daysSinceAssistantUse,
    `${path}.daysSinceAssistantUse`,
  );
  const engagementStatus = dashboardAttentionEngagementStatusAt(
    record.engagementStatus,
    `${path}.engagementStatus`,
  );
  const assistantInteractionsLast7Days = nonNegativeIntegerAt(
    record.assistantInteractionsLast7Days,
    `${path}.assistantInteractionsLast7Days`,
  );
  const homeworkAssignedCount = nonNegativeIntegerAt(
    record.homeworkAssignedCount,
    `${path}.homeworkAssignedCount`,
  );
  const homeworkCompletedCount = nonNegativeIntegerAt(
    record.homeworkCompletedCount,
    `${path}.homeworkCompletedCount`,
  );
  const completionRate = percentageAt(
    record.completionRate,
    `${path}.completionRate`,
  );

  if (
    (lastAssistantUseAt === null) !== (daysSinceAssistantUse === null) ||
    (assistantInteractionsLast7Days > 0 && lastAssistantUseAt === null) ||
    homeworkCompletedCount > homeworkAssignedCount
  ) {
    return invalid(path);
  }

  if (engagementStatus === "new-client") {
    if (
      homeworkAssignedCount !== 0 ||
      homeworkCompletedCount !== 0 ||
      completionRate !== null
    ) {
      return invalid(path);
    }
  } else {
    if (homeworkAssignedCount === 0 || completionRate === null) {
      return invalid(path);
    }
    const calculatedRate =
      Math.round((homeworkCompletedCount / homeworkAssignedCount) * 1000) / 10;
    if (Math.abs(completionRate - calculatedRate) > 0.001) {
      return invalid(`${path}.completionRate`);
    }

    if (
      (engagementStatus === "no-recent-assistant-use" &&
        assistantInteractionsLast7Days !== 0) ||
      (engagementStatus !== "no-recent-assistant-use" &&
        assistantInteractionsLast7Days === 0) ||
      (engagementStatus === "on-track" && completionRate < 60) ||
      (engagementStatus === "needs-follow-up" && completionRate >= 60)
    ) {
      return invalid(path);
    }
  }

  return {
    clientId: nonEmptyStringAt(record.clientId, `${path}.clientId`),
    accessCode: nonEmptyStringAt(record.accessCode, `${path}.accessCode`),
    nickname: stringAt(record.nickname, `${path}.nickname`),
    engagementStatus,
    reasonCode: nonEmptyStringAt(record.reasonCode, `${path}.reasonCode`),
    lastAssistantUseAt,
    daysSinceAssistantUse,
    assistantInteractionsLast7Days,
    homeworkAssignedCount,
    homeworkCompletedCount,
    completionRate,
  };
}

function dashboardAttentionSummaryAt(
  value: unknown,
  path: string,
): DashboardAttentionSummary {
  const record = objectAt(value, path);
  return {
    activatedClients: nonNegativeIntegerAt(
      record.activatedClients,
      `${path}.activatedClients`,
    ),
    newClients: nonNegativeIntegerAt(record.newClients, `${path}.newClients`),
    clientsOnTrack: nonNegativeIntegerAt(
      record.clientsOnTrack,
      `${path}.clientsOnTrack`,
    ),
    clientsNeedingFollowUp: nonNegativeIntegerAt(
      record.clientsNeedingFollowUp,
      `${path}.clientsNeedingFollowUp`,
    ),
    clientsWithNoRecentAssistantUse: nonNegativeIntegerAt(
      record.clientsWithNoRecentAssistantUse,
      `${path}.clientsWithNoRecentAssistantUse`,
    ),
    clientsWithSafetyEvents: nonNegativeIntegerAt(
      record.clientsWithSafetyEvents,
      `${path}.clientsWithSafetyEvents`,
    ),
    totalSafetyDetections: nonNegativeIntegerAt(
      record.totalSafetyDetections,
      `${path}.totalSafetyDetections`,
    ),
    sessionsWithSafetyDetections: nonNegativeIntegerAt(
      record.sessionsWithSafetyDetections,
      `${path}.sessionsWithSafetyDetections`,
    ),
    clientsWithNoActivityLast7Days: nonNegativeIntegerAt(
      record.clientsWithNoActivityLast7Days,
      `${path}.clientsWithNoActivityLast7Days`,
    ),
    clientsWithNoActivityThisWeek: nonNegativeIntegerAt(
      record.clientsWithNoActivityThisWeek,
      `${path}.clientsWithNoActivityThisWeek`,
    ),
  };
}

export function parseGetDashboardAttentionEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  DashboardAttentionReportData,
  "portal.reports.getDashboardAttention"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.reports.getDashboardAttention") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.reports.getDashboardAttention") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.report !== "dashboardAttention") return invalid("data.report");
  if (data.timezone !== "America/Los_Angeles") {
    return invalid("data.timezone");
  }
  if (!Array.isArray(data.safetyClients)) {
    return invalid("data.safetyClients");
  }
  if (!Array.isArray(data.inactiveClients)) {
    return invalid("data.inactiveClients");
  }
  if (!Array.isArray(data.engagementClients)) {
    return invalid("data.engagementClients");
  }

  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const safetyWindowRecord = objectAt(data.safetyWindow, "data.safetyWindow");
  const assistantUseWindowRecord = objectAt(
    data.assistantUseWindow,
    "data.assistantUseWindow",
  );
  const inactivityWindowRecord = objectAt(
    data.inactivityWindow,
    "data.inactivityWindow",
  );
  const homeworkCompletionBasisRecord = objectAt(
    data.homeworkCompletionBasis,
    "data.homeworkCompletionBasis",
  );
  if (safetyWindowRecord.range !== "last_7_days") {
    return invalid("data.safetyWindow.range");
  }
  if (assistantUseWindowRecord.range !== "last_7_days") {
    return invalid("data.assistantUseWindow.range");
  }
  if (inactivityWindowRecord.range !== "last_7_days") {
    return invalid("data.inactivityWindow.range");
  }
  if (
    homeworkCompletionBasisRecord.range !== "all_time" ||
    homeworkCompletionBasisRecord.denominator !== "all_assignments"
  ) {
    return invalid("data.homeworkCompletionBasis");
  }
  const safetyWindow = {
    range: "last_7_days" as const,
    startDate: timestampAt(
      safetyWindowRecord.startDate,
      "data.safetyWindow.startDate",
    ),
    endDate: timestampAt(
      safetyWindowRecord.endDate,
      "data.safetyWindow.endDate",
    ),
  };
  const inactivityWindow = {
    range: "last_7_days" as const,
    startDate: timestampAt(
      inactivityWindowRecord.startDate,
      "data.inactivityWindow.startDate",
    ),
    endDate: timestampAt(
      inactivityWindowRecord.endDate,
      "data.inactivityWindow.endDate",
    ),
  };
  const assistantUseWindow = {
    range: "last_7_days" as const,
    startDate: timestampAt(
      assistantUseWindowRecord.startDate,
      "data.assistantUseWindow.startDate",
    ),
    endDate: timestampAt(
      assistantUseWindowRecord.endDate,
      "data.assistantUseWindow.endDate",
    ),
  };
  if (
    Date.parse(safetyWindow.startDate) >= Date.parse(safetyWindow.endDate) ||
    Date.parse(assistantUseWindow.startDate) >=
      Date.parse(assistantUseWindow.endDate) ||
    Date.parse(inactivityWindow.startDate) >=
      Date.parse(inactivityWindow.endDate)
  ) {
    return invalid("data.windows");
  }

  const summary = dashboardAttentionSummaryAt(data.summary, "data.summary");
  const safetyClients = data.safetyClients.map((client, index) =>
    dashboardAttentionSafetyClientAt(client, `data.safetyClients[${index}]`),
  );
  const inactiveClients = data.inactiveClients.map((client, index) =>
    dashboardAttentionInactiveClientAt(
      client,
      `data.inactiveClients[${index}]`,
    ),
  );
  const engagementClients = data.engagementClients.map((client, index) =>
    dashboardAttentionEngagementClientAt(
      client,
      `data.engagementClients[${index}]`,
    ),
  );
  const safetyDetections = safetyClients.reduce(
    (total, client) => total + client.safetyDetectionCount,
    0,
  );
  const safetySessions = safetyClients.reduce(
    (total, client) => total + client.sessionsWithSafetyDetections,
    0,
  );
  const engagementStatusCounts = engagementClients.reduce(
    (counts, client) => {
      counts[client.engagementStatus] += 1;
      return counts;
    },
    {
      "new-client": 0,
      "on-track": 0,
      "needs-follow-up": 0,
      "no-recent-assistant-use": 0,
    } satisfies Record<DashboardAttentionEngagementStatus, number>,
  );
  if (
    summary.clientsWithSafetyEvents !== safetyClients.length ||
    summary.totalSafetyDetections !== safetyDetections ||
    summary.sessionsWithSafetyDetections !== safetySessions ||
    summary.clientsWithNoActivityLast7Days !== inactiveClients.length ||
    summary.activatedClients !== engagementClients.length ||
    summary.newClients !== engagementStatusCounts["new-client"] ||
    summary.clientsOnTrack !== engagementStatusCounts["on-track"] ||
    summary.clientsNeedingFollowUp !==
      engagementStatusCounts["needs-follow-up"] ||
    summary.clientsWithNoRecentAssistantUse !==
      engagementStatusCounts["no-recent-assistant-use"] ||
    summary.newClients +
      summary.clientsOnTrack +
      summary.clientsNeedingFollowUp +
      summary.clientsWithNoRecentAssistantUse !==
      summary.activatedClients
  ) {
    return invalid("data.summary");
  }
  if (
    new Set(engagementClients.map((client) => client.clientId)).size !==
      engagementClients.length ||
    new Set(engagementClients.map((client) => client.accessCode)).size !==
      engagementClients.length
  ) {
    return invalid("data.engagementClients");
  }
  if (
    safetyClients.some(
      (client, index) =>
        index > 0 &&
        Date.parse(safetyClients[index - 1].lastSafetyEventAt) <
          Date.parse(client.lastSafetyEventAt),
    )
  ) {
    return invalid("data.safetyClients");
  }
  if (
    inactiveClients.some((client, index) => {
      if (index === 0) return false;
      const previous = inactiveClients[index - 1];
      if (previous.daysSinceActive === null) return false;
      if (client.daysSinceActive === null) return true;
      return previous.daysSinceActive < client.daysSinceActive;
    })
  ) {
    return invalid("data.inactiveClients");
  }
  if (found && authorized && !therapist) {
    return invalid("data.authorizedDashboardAttention");
  }
  if (
    (!found || !authorized) &&
    (safetyClients.length || inactiveClients.length || engagementClients.length)
  ) {
    return invalid("data.authorizationScope");
  }

  return {
    apiVersion: "1",
    operation: "portal.reports.getDashboardAttention",
    data: {
      success: true,
      found,
      authorized,
      operation: "portal.reports.getDashboardAttention",
      db: "supabase",
      therapist,
      report: "dashboardAttention",
      generatedAt: timestampAt(data.generatedAt, "data.generatedAt"),
      timezone: "America/Los_Angeles",
      asOfDate: calendarDateAt(data.asOfDate, "data.asOfDate"),
      safetyWindow,
      assistantUseWindow,
      inactivityWindow,
      homeworkCompletionBasis: {
        range: "all_time",
        denominator: "all_assignments",
      },
      summary,
      engagementClients,
      safetyClients,
      inactiveClients,
    },
    error: null,
  };
}

function supervisorTeamAttentionEngagementClientAt(
  value: unknown,
  path: string,
): SupervisorTeamAttentionEngagementClient {
  const record = objectAt(value, path);
  return {
    ...dashboardAttentionEngagementClientAt(record, path),
    clinicId: nonEmptyStringAt(record.clinicId, `${path}.clinicId`),
    clinicName: nonEmptyStringAt(record.clinicName, `${path}.clinicName`),
    assignedTherapists: assignedCliniciansAt(
      record.assignedTherapists,
      `${path}.assignedTherapists`,
    ),
  };
}

function supervisorTeamAttentionSafetyClientAt(
  value: unknown,
  path: string,
): SupervisorTeamAttentionSafetyClient {
  const record = objectAt(value, path);
  return {
    ...dashboardAttentionSafetyClientAt(record, path),
    clinicId: nonEmptyStringAt(record.clinicId, `${path}.clinicId`),
    clinicName: nonEmptyStringAt(record.clinicName, `${path}.clinicName`),
    assignedTherapists: assignedCliniciansAt(
      record.assignedTherapists,
      `${path}.assignedTherapists`,
    ),
  };
}

function supervisorTeamAttentionClientAt(
  value: unknown,
  path: string,
): SupervisorTeamAttentionClient {
  const record = objectAt(value, path);
  return {
    ...supervisorTeamAttentionEngagementClientAt(record, path),
    reasons: stringArrayAt(record.reasons, `${path}.reasons`),
  };
}

export function parseGetSupervisorTeamAttentionEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SupervisorTeamAttentionData,
  "portal.supervisor.getTeamAttention"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.supervisor.getTeamAttention") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.supervisor.getTeamAttention") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.timezone !== "America/Los_Angeles") {
    return invalid("data.timezone");
  }
  if (!Array.isArray(data.clinics)) return invalid("data.clinics");
  if (!Array.isArray(data.teamMembers)) return invalid("data.teamMembers");
  if (!Array.isArray(data.clients)) return invalid("data.clients");
  if (!Array.isArray(data.engagementClients)) {
    return invalid("data.engagementClients");
  }
  if (!Array.isArray(data.safetyClients)) {
    return invalid("data.safetyClients");
  }
  if (!Array.isArray(data.attentionClients)) {
    return invalid("data.attentionClients");
  }

  const summaryRecord = objectAt(data.summary, "data.summary");
  const parsedData: SupervisorTeamAttentionData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.supervisor.getTeamAttention",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    clinicOptions: supervisorClinicOptionsAt(data),
    clinics: data.clinics.map((clinic, index) =>
      supervisorClinicSummaryAt(clinic, `data.clinics[${index}]`),
    ),
    teamMembers: data.teamMembers.map((teamMember, index) =>
      supervisorTeamMemberAt(teamMember, `data.teamMembers[${index}]`),
    ),
    clients: data.clients.map((client, index) =>
      supervisorTeamClientAt(client, `data.clients[${index}]`),
    ),
    generatedAt: timestampAt(data.generatedAt, "data.generatedAt"),
    timezone: "America/Los_Angeles",
    asOfDate: calendarDateAt(data.asOfDate, "data.asOfDate"),
    engagementClients: data.engagementClients.map((client, index) =>
      supervisorTeamAttentionEngagementClientAt(
        client,
        `data.engagementClients[${index}]`,
      ),
    ),
    safetyClients: data.safetyClients.map((client, index) =>
      supervisorTeamAttentionSafetyClientAt(
        client,
        `data.safetyClients[${index}]`,
      ),
    ),
    attentionClients: data.attentionClients.map((client, index) =>
      supervisorTeamAttentionClientAt(
        client,
        `data.attentionClients[${index}]`,
      ),
    ),
    summary: {
      activatedClients: nonNegativeIntegerAt(
        summaryRecord.activatedClients,
        "data.summary.activatedClients",
      ),
      clientsNeedingAttention: nonNegativeIntegerAt(
        summaryRecord.clientsNeedingAttention,
        "data.summary.clientsNeedingAttention",
      ),
      clientsNeedingFollowUp: nonNegativeIntegerAt(
        summaryRecord.clientsNeedingFollowUp,
        "data.summary.clientsNeedingFollowUp",
      ),
      clientsWithNoRecentAssistantUse: nonNegativeIntegerAt(
        summaryRecord.clientsWithNoRecentAssistantUse,
        "data.summary.clientsWithNoRecentAssistantUse",
      ),
      clientsWithNoHomework: nonNegativeIntegerAt(
        summaryRecord.clientsWithNoHomework,
        "data.summary.clientsWithNoHomework",
      ),
      clientsOnTrack: nonNegativeIntegerAt(
        summaryRecord.clientsOnTrack,
        "data.summary.clientsOnTrack",
      ),
      clientsWithSafetyEvents: nonNegativeIntegerAt(
        summaryRecord.clientsWithSafetyEvents,
        "data.summary.clientsWithSafetyEvents",
      ),
      totalSafetyDetections: nonNegativeIntegerAt(
        summaryRecord.totalSafetyDetections,
        "data.summary.totalSafetyDetections",
      ),
    },
  };

  const clientIds = new Set(parsedData.clients.map((client) => client.id));
  const teamMemberIds = new Set(
    parsedData.teamMembers.map((teamMember) => teamMember.id),
  );
  const uniqueClientIds = (clients: Array<{ clientId: string }>) =>
    new Set(clients.map((client) => client.clientId)).size === clients.length;
  const clientsBelongToScope = (clients: Array<{ clientId: string }>) =>
    clients.every((client) => clientIds.has(client.clientId));
  const assignedTherapistsBelongToTeam = (
    clients: Array<{ assignedTherapists: Array<{ id: string }> }>,
  ) =>
    clients.every((client) =>
      client.assignedTherapists.every((therapist) =>
        teamMemberIds.has(therapist.id),
      ),
    );

  if (
    clientIds.size !== parsedData.clients.length ||
    teamMemberIds.size !== parsedData.teamMembers.length ||
    !uniqueClientIds(parsedData.engagementClients) ||
    !uniqueClientIds(parsedData.safetyClients) ||
    !uniqueClientIds(parsedData.attentionClients) ||
    !clientsBelongToScope(parsedData.engagementClients) ||
    !clientsBelongToScope(parsedData.safetyClients) ||
    !clientsBelongToScope(parsedData.attentionClients) ||
    !assignedTherapistsBelongToTeam(parsedData.clients) ||
    !assignedTherapistsBelongToTeam(parsedData.engagementClients) ||
    !assignedTherapistsBelongToTeam(parsedData.safetyClients) ||
    !assignedTherapistsBelongToTeam(parsedData.attentionClients)
  ) {
    return invalid("data.teamScope");
  }

  const engagementByClientId = new Map(
    parsedData.engagementClients.map((client) => [client.clientId, client]),
  );
  if (
    parsedData.attentionClients.some(
      (client) => !engagementByClientId.has(client.clientId),
    )
  ) {
    return invalid("data.attentionClients");
  }

  const summary = parsedData.summary;
  if (
    summary.activatedClients !==
      parsedData.clients.filter(
        (client) => client.status.trim().toLowerCase() === "activated",
      ).length ||
    summary.clientsNeedingAttention !== parsedData.attentionClients.length ||
    summary.clientsNeedingFollowUp !==
      parsedData.engagementClients.filter(
        (client) => client.engagementStatus === "needs-follow-up",
      ).length ||
    summary.clientsWithNoRecentAssistantUse !==
      parsedData.engagementClients.filter(
        (client) => client.assistantInteractionsLast7Days === 0,
      ).length ||
    summary.clientsWithNoHomework !==
      parsedData.engagementClients.filter(
        (client) => client.homeworkAssignedCount === 0,
      ).length ||
    summary.clientsOnTrack !==
      parsedData.engagementClients.filter(
        (client) => client.engagementStatus === "on-track",
      ).length ||
    summary.clientsWithSafetyEvents !== parsedData.safetyClients.length ||
    summary.totalSafetyDetections !==
      parsedData.safetyClients.reduce(
        (total, client) => total + client.safetyDetectionCount,
        0,
      )
  ) {
    return invalid("data.summary");
  }

  if (
    parsedData.authorized &&
    (!parsedData.found ||
      parsedData.therapist?.role !== "supervisor" ||
      parsedData.teamMembers.filter((member) => member.isCurrentUser).length !==
        1 ||
      parsedData.teamMembers.find((member) => member.isCurrentUser)?.id !==
        parsedData.therapist.id)
  ) {
    return invalid("data.authorized");
  }

  return {
    apiVersion: "1",
    operation: "portal.supervisor.getTeamAttention",
    data: parsedData,
    error: null,
  };
}

function clientValueMutationAt(
  data: JsonObject,
  operation:
    | "portal.createClientValue"
    | "portal.updateClientValue"
    | "portal.setClientValueEnabled",
  resultKey: "created" | "updated",
) {
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");
  if (data[resultKey] !== true) return invalid(`data.${resultKey}`);

  const clientValue = clientValueAt(data.value, "data.value");

  return { clientValue };
}

export function parseCreateClientValueEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CreateClientValueData,
  "portal.createClientValue"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.createClientValue") {
    return invalid("operation");
  }
  const parsed = clientValueMutationAt(
    objectAt(record.data, "data"),
    "portal.createClientValue",
    "created",
  );
  return {
    apiVersion: "1",
    operation: "portal.createClientValue",
    data: {
      success: true,
      created: true,
      operation: "portal.createClientValue",
      db: "supabase",
      value: parsed.clientValue,
    },
    error: null,
  };
}

export function parseUpdateClientValueEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  UpdateClientValueData,
  "portal.updateClientValue"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.updateClientValue") {
    return invalid("operation");
  }
  const parsed = clientValueMutationAt(
    objectAt(record.data, "data"),
    "portal.updateClientValue",
    "updated",
  );
  return {
    apiVersion: "1",
    operation: "portal.updateClientValue",
    data: {
      success: true,
      updated: true,
      operation: "portal.updateClientValue",
      db: "supabase",
      value: parsed.clientValue,
    },
    error: null,
  };
}

export function parseSetClientValueEnabledEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SetClientValueEnabledData,
  "portal.setClientValueEnabled"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.setClientValueEnabled") {
    return invalid("operation");
  }
  const parsed = clientValueMutationAt(
    objectAt(record.data, "data"),
    "portal.setClientValueEnabled",
    "updated",
  );
  return {
    apiVersion: "1",
    operation: "portal.setClientValueEnabled",
    data: {
      success: true,
      updated: true,
      operation: "portal.setClientValueEnabled",
      db: "supabase",
      value: parsed.clientValue,
    },
    error: null,
  };
}

export function parseGetRankLevelsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<RankLevelsData, "portal.getRankLevels"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getRankLevels") return invalid("operation");

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getRankLevels") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (!Array.isArray(data.rankLevels)) return invalid("data.rankLevels");

  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  if (found && authorized && !therapist) {
    return invalid("data.authorizedRankLevels");
  }

  return {
    apiVersion: "1",
    operation: "portal.getRankLevels",
    data: {
      success: true,
      found,
      authorized,
      operation: "portal.getRankLevels",
      db: "supabase",
      therapist,
      patient: null,
      rankLevels: data.rankLevels.map((rankLevel, index) =>
        rankLevelAt(rankLevel, `data.rankLevels[${index}]`),
      ),
      ...clientRecordAccessFields(data),
    },
    error: null,
  };
}

export function parseGetClientRankLevelRulesEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  ClientRankLevelRulesData,
  "portal.getClientRankLevelRules"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getClientRankLevelRules") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getClientRankLevelRules") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.rules)) return invalid("data.rules");

  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const patient = nullablePatientAt(data.patient, "data.patient");
  const rules = data.rules.map((rule, index) =>
    clientRankLevelRuleAt(rule, `data.rules[${index}]`),
  );

  if (found && authorized && (!therapist || !patient)) {
    return invalid("data.authorizedClientRankLevelRules");
  }
  if (patient && rules.some((rule) => rule.patientId !== patient.id)) {
    return invalid("data.rules.patientId");
  }

  return {
    apiVersion: "1",
    operation: "portal.getClientRankLevelRules",
    data: {
      success: true,
      found,
      authorized,
      operation: "portal.getClientRankLevelRules",
      db: "supabase",
      therapist,
      patient,
      rules,
      ...clientRecordAccessFields(data),
    },
    error: null,
  };
}

function clientRankLevelRuleMutationAt(
  data: JsonObject,
  operation:
    | "portal.createClientRankLevelRule"
    | "portal.updateClientRankLevelRule"
    | "portal.setClientRankLevelRuleEnabled",
  resultKey: "created" | "updated",
) {
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");
  if (data[resultKey] !== true) return invalid(`data.${resultKey}`);

  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const patient = nullablePatientAt(data.patient, "data.patient");
  const rule = clientRankLevelRuleAt(data.rule, "data.rule");
  if (!found || !authorized || !therapist || !patient) {
    return invalid("data.successfulClientRankLevelRuleMutation");
  }
  if (rule.patientId !== patient.id) return invalid("data.rule.patientId");

  return { therapist, patient, rule };
}

export function parseCreateClientRankLevelRuleEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CreateClientRankLevelRuleData,
  "portal.createClientRankLevelRule"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.createClientRankLevelRule") {
    return invalid("operation");
  }
  const parsed = clientRankLevelRuleMutationAt(
    objectAt(record.data, "data"),
    "portal.createClientRankLevelRule",
    "created",
  );
  return {
    apiVersion: "1",
    operation: "portal.createClientRankLevelRule",
    data: {
      success: true,
      found: true,
      authorized: true,
      created: true,
      operation: "portal.createClientRankLevelRule",
      db: "supabase",
      therapist: parsed.therapist,
      patient: parsed.patient,
      rule: parsed.rule,
    },
    error: null,
  };
}

export function parseUpdateClientRankLevelRuleEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  UpdateClientRankLevelRuleData,
  "portal.updateClientRankLevelRule"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.updateClientRankLevelRule") {
    return invalid("operation");
  }
  const parsed = clientRankLevelRuleMutationAt(
    objectAt(record.data, "data"),
    "portal.updateClientRankLevelRule",
    "updated",
  );
  return {
    apiVersion: "1",
    operation: "portal.updateClientRankLevelRule",
    data: {
      success: true,
      found: true,
      authorized: true,
      updated: true,
      operation: "portal.updateClientRankLevelRule",
      db: "supabase",
      therapist: parsed.therapist,
      patient: parsed.patient,
      rule: parsed.rule,
    },
    error: null,
  };
}

export function parseSetClientRankLevelRuleEnabledEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SetClientRankLevelRuleEnabledData,
  "portal.setClientRankLevelRuleEnabled"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.setClientRankLevelRuleEnabled") {
    return invalid("operation");
  }
  const parsed = clientRankLevelRuleMutationAt(
    objectAt(record.data, "data"),
    "portal.setClientRankLevelRuleEnabled",
    "updated",
  );
  return {
    apiVersion: "1",
    operation: "portal.setClientRankLevelRuleEnabled",
    data: {
      success: true,
      found: true,
      authorized: true,
      updated: true,
      operation: "portal.setClientRankLevelRuleEnabled",
      db: "supabase",
      therapist: parsed.therapist,
      patient: parsed.patient,
      rule: parsed.rule,
    },
    error: null,
  };
}

function copingSkillGuidesAt(data: JsonObject): CopingSkillGuide[] {
  if (!Array.isArray(data.guides)) return invalid("data.guides");
  return data.guides.map((guide, index) =>
    copingSkillGuideAt(guide, `data.guides[${index}]`),
  );
}

export function parseGetCopingSkillsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<CopingSkillsData, "portal.getCopingSkills"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getCopingSkills") {
    return invalid("operation");
  }
  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getCopingSkills") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  if (found && authorized && !therapist) {
    return invalid("data.authorizedCopingSkills");
  }
  return {
    apiVersion: "1",
    operation: "portal.getCopingSkills",
    data: {
      success: true,
      found,
      authorized,
      operation: "portal.getCopingSkills",
      db: "supabase",
      therapist,
      patient: null,
      guides: copingSkillGuidesAt(data),
      ...clientRecordAccessFields(data),
    },
    error: null,
  };
}

export function parseGetClientCopingSkillsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  ClientCopingSkillsData,
  "portal.getClientCopingSkills"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getClientCopingSkills") {
    return invalid("operation");
  }
  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getClientCopingSkills") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const patient = nullablePatientAt(data.patient, "data.patient");
  if (found && authorized && (!therapist || !patient)) {
    return invalid("data.authorizedClientCopingSkills");
  }
  return {
    apiVersion: "1",
    operation: "portal.getClientCopingSkills",
    data: {
      success: true,
      found,
      authorized,
      operation: "portal.getClientCopingSkills",
      db: "supabase",
      therapist,
      patient,
      guides: copingSkillGuidesAt(data),
      ...clientRecordAccessFields(data),
    },
    error: null,
  };
}

type CopingSkillMutationOperation =
  | "portal.createCopingSkill"
  | "portal.updateCopingSkill"
  | "portal.setCopingSkillEnabled"
  | "portal.createClientCopingSkill"
  | "portal.updateClientCopingSkill"
  | "portal.setClientCopingSkillEnabled";

function copingSkillMutationAt(
  data: JsonObject,
  operation: CopingSkillMutationOperation,
  resultKey: "created" | "updated",
  personalized: boolean,
) {
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");
  if (data[resultKey] !== true) return invalid(`data.${resultKey}`);
  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const patient = nullablePatientAt(data.patient, "data.patient");
  const guide = copingSkillGuideAt(data.guide, "data.guide");
  if (!found || !authorized || !therapist) {
    return invalid("data.successfulCopingSkillMutation");
  }
  if (personalized) {
    if (!patient || guide.patientId !== patient.id) {
      return invalid("data.guide.patientId");
    }
  } else if (patient !== null || guide.patientId !== null) {
    return invalid("data.guide.patientId");
  }
  return { therapist, patient, guide };
}

function parseCopingSkillMutation(
  value: unknown,
  operation: CopingSkillMutationOperation,
  resultKey: "created" | "updated",
  personalized: boolean,
) {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== operation) return invalid("operation");
  return copingSkillMutationAt(
    objectAt(record.data, "data"),
    operation,
    resultKey,
    personalized,
  );
}

export function parseCreateCopingSkillEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CreateCopingSkillData,
  "portal.createCopingSkill"
> {
  const parsed = parseCopingSkillMutation(
    value,
    "portal.createCopingSkill",
    "created",
    false,
  );
  if ("error" in parsed) return parsed;
  return {
    apiVersion: "1",
    operation: "portal.createCopingSkill",
    data: {
      success: true,
      found: true,
      authorized: true,
      created: true,
      operation: "portal.createCopingSkill",
      db: "supabase",
      therapist: parsed.therapist,
      patient: null,
      guide: parsed.guide,
    },
    error: null,
  };
}

export function parseUpdateCopingSkillEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  UpdateCopingSkillData,
  "portal.updateCopingSkill"
> {
  const parsed = parseCopingSkillMutation(
    value,
    "portal.updateCopingSkill",
    "updated",
    false,
  );
  if ("error" in parsed) return parsed;
  return {
    apiVersion: "1",
    operation: "portal.updateCopingSkill",
    data: {
      success: true,
      found: true,
      authorized: true,
      updated: true,
      operation: "portal.updateCopingSkill",
      db: "supabase",
      therapist: parsed.therapist,
      patient: null,
      guide: parsed.guide,
    },
    error: null,
  };
}

export function parseSetCopingSkillEnabledEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SetCopingSkillEnabledData,
  "portal.setCopingSkillEnabled"
> {
  const parsed = parseCopingSkillMutation(
    value,
    "portal.setCopingSkillEnabled",
    "updated",
    false,
  );
  if ("error" in parsed) return parsed;
  return {
    apiVersion: "1",
    operation: "portal.setCopingSkillEnabled",
    data: {
      success: true,
      found: true,
      authorized: true,
      updated: true,
      operation: "portal.setCopingSkillEnabled",
      db: "supabase",
      therapist: parsed.therapist,
      patient: null,
      guide: parsed.guide,
    },
    error: null,
  };
}

export function parseCreateClientCopingSkillEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CreateClientCopingSkillData,
  "portal.createClientCopingSkill"
> {
  const parsed = parseCopingSkillMutation(
    value,
    "portal.createClientCopingSkill",
    "created",
    true,
  );
  if ("error" in parsed) return parsed;
  return {
    apiVersion: "1",
    operation: "portal.createClientCopingSkill",
    data: {
      success: true,
      found: true,
      authorized: true,
      created: true,
      operation: "portal.createClientCopingSkill",
      db: "supabase",
      therapist: parsed.therapist,
      patient: parsed.patient!,
      guide: parsed.guide,
    },
    error: null,
  };
}

export function parseUpdateClientCopingSkillEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  UpdateClientCopingSkillData,
  "portal.updateClientCopingSkill"
> {
  const parsed = parseCopingSkillMutation(
    value,
    "portal.updateClientCopingSkill",
    "updated",
    true,
  );
  if ("error" in parsed) return parsed;
  return {
    apiVersion: "1",
    operation: "portal.updateClientCopingSkill",
    data: {
      success: true,
      found: true,
      authorized: true,
      updated: true,
      operation: "portal.updateClientCopingSkill",
      db: "supabase",
      therapist: parsed.therapist,
      patient: parsed.patient!,
      guide: parsed.guide,
    },
    error: null,
  };
}

export function parseSetClientCopingSkillEnabledEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SetClientCopingSkillEnabledData,
  "portal.setClientCopingSkillEnabled"
> {
  const parsed = parseCopingSkillMutation(
    value,
    "portal.setClientCopingSkillEnabled",
    "updated",
    true,
  );
  if ("error" in parsed) return parsed;
  return {
    apiVersion: "1",
    operation: "portal.setClientCopingSkillEnabled",
    data: {
      success: true,
      found: true,
      authorized: true,
      updated: true,
      operation: "portal.setClientCopingSkillEnabled",
      db: "supabase",
      therapist: parsed.therapist,
      patient: parsed.patient!,
      guide: parsed.guide,
    },
    error: null,
  };
}

export function parseGetRecordFormConfigEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  RecordFormConfigData,
  "portal.getRecordFormConfig"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getRecordFormConfig") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getRecordFormConfig") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.recordType !== "client") return invalid("data.recordType");
  if (!Array.isArray(data.fields)) return invalid("data.fields");

  const fields = data.fields.map((field, index) =>
    recordFormFieldAt(field, `data.fields[${index}]`),
  );
  const parsedData: RecordFormConfigData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getRecordFormConfig",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    recordType: "client",
    fieldCount: integerAt(data.fieldCount, "data.fieldCount"),
    lovCatalogCount: integerAt(data.lovCatalogCount, "data.lovCatalogCount"),
    resolvedLovCatalogCount: integerAt(
      data.resolvedLovCatalogCount,
      "data.resolvedLovCatalogCount",
    ),
    missingLovCatalogKeys: stringArrayAt(
      data.missingLovCatalogKeys,
      "data.missingLovCatalogKeys",
    ),
    fields,
  };

  if (parsedData.fieldCount !== fields.length)
    return invalid("data.fieldCount");
  if (parsedData.found && parsedData.authorized && !parsedData.therapist) {
    return invalid("data.authorizedFormConfig");
  }

  return {
    apiVersion: "1",
    operation: "portal.getRecordFormConfig",
    data: parsedData,
    error: null,
  };
}

export function parseGetRelationOptionsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  RelationOptionsData,
  "portal.getRelationOptions"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getRelationOptions") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getRelationOptions") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.recordType !== "client") return invalid("data.recordType");
  if (data.fieldKey !== "clinicId") return invalid("data.fieldKey");
  if (data.relationSourceKey !== "clinics") {
    return invalid("data.relationSourceKey");
  }
  if (!Array.isArray(data.options)) return invalid("data.options");

  const parsedData: RelationOptionsData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getRelationOptions",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    recordType: "client",
    fieldKey: "clinicId",
    relationSourceKey: "clinics",
    options: data.options.map((option, index) =>
      relationOptionAt(option, `data.options[${index}]`),
    ),
  };

  if (parsedData.found && parsedData.authorized && !parsedData.therapist) {
    return invalid("data.authorizedRelationOptions");
  }

  return {
    apiVersion: "1",
    operation: "portal.getRelationOptions",
    data: parsedData,
    error: null,
  };
}

function clientMutationAt(
  data: JsonObject,
  operation: "portal.createClient" | "portal.updateClient",
  resultKey: "created" | "updated",
) {
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");
  if (data[resultKey] !== true) return invalid(`data.${resultKey}`);

  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const patient = clientMutationPatientAt(data.patient, "data.patient");
  if (!found || !authorized || !therapist) {
    return invalid("data.successfulClientMutation");
  }
  return { found, authorized, therapist, patient };
}

export function parseCreateClientEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<CreateClientData, "portal.createClient"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.createClient") return invalid("operation");
  const parsed = clientMutationAt(
    objectAt(record.data, "data"),
    "portal.createClient",
    "created",
  );
  return {
    apiVersion: "1",
    operation: "portal.createClient",
    data: {
      success: true,
      found: parsed.found,
      authorized: parsed.authorized,
      created: true,
      operation: "portal.createClient",
      db: "supabase",
      therapist: parsed.therapist,
      patient: parsed.patient,
    },
    error: null,
  };
}

export function parseUpdateClientEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<UpdateClientData, "portal.updateClient"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.updateClient") return invalid("operation");
  const parsed = clientMutationAt(
    objectAt(record.data, "data"),
    "portal.updateClient",
    "updated",
  );
  return {
    apiVersion: "1",
    operation: "portal.updateClient",
    data: {
      success: true,
      found: parsed.found,
      authorized: parsed.authorized,
      updated: true,
      operation: "portal.updateClient",
      db: "supabase",
      therapist: parsed.therapist,
      patient: parsed.patient,
    },
    error: null,
  };
}

export function parseGetCurrentHomeworkEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CurrentHomeworkPageData,
  "portal.getCurrentHomework"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getCurrentHomework") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getCurrentHomework") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.assignments)) return invalid("data.assignments");
  if (!Array.isArray(data.templates)) return invalid("data.templates");

  const parsedData: CurrentHomeworkPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getCurrentHomework",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    assignments: data.assignments.map((assignment, index) =>
      currentHomeworkAssignmentAt(assignment, `data.assignments[${index}]`),
    ),
    templates: data.templates.map((template, index) =>
      currentHomeworkTemplateAt(template, `data.templates[${index}]`),
    ),
    ...clientRecordAccessFields(data),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || !parsedData.patient)
  ) {
    return invalid("data.authorizedCurrentHomework");
  }

  return {
    apiVersion: "1",
    operation: "portal.getCurrentHomework",
    data: parsedData,
    error: null,
  };
}

export function parseGetClientSessionTranscriptEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  ClientSessionTranscriptData,
  "portal.getClientSessionTranscript"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getClientSessionTranscript")
    return invalid("operation");
  const data = objectAt(record.data, "data");
  if (data.success !== true || data.found !== true || data.authorized !== true)
    return invalid("data.authorizedTranscript");
  if (data.operation !== record.operation || data.db !== "supabase")
    return invalid("data.operation");
  const countAt = (value: unknown, path: string) => {
    const result = nonNegativeIntegerAt(value, path);
    if (!Number.isSafeInteger(result)) return invalid(path);
    return result;
  };
  const timestampAt = (value: unknown, path: string) => {
    const result = nonEmptyStringAt(value, path);
    if (!Number.isFinite(Date.parse(result))) return invalid(path);
    return result;
  };
  const patient = nullablePatientAt(data.patient, "data.patient");
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  if (!patient || !therapist) return invalid("data.authorizedTranscript");
  const sessionId = nonEmptyStringAt(data.sessionId, "data.sessionId");
  const rawSession = objectAt(data.session, "data.session");
  const session = {
    sessionId: nonEmptyStringAt(rawSession.sessionId, "data.session.sessionId"),
    startedAt: timestampAt(rawSession.startedAt, "data.session.startedAt"),
    lastMessageAt: timestampAt(
      rawSession.lastMessageAt,
      "data.session.lastMessageAt",
    ),
    messageCount: countAt(rawSession.messageCount, "data.session.messageCount"),
  };
  if (
    sessionId.length > 200 ||
    session.sessionId !== sessionId ||
    session.messageCount < 1 ||
    Date.parse(session.startedAt) > Date.parse(session.lastMessageAt)
  )
    return invalid("data.session");
  const pageSize = countAt(data.pageSize, "data.pageSize");
  const pageOffset = countAt(data.pageOffset, "data.pageOffset");
  if (pageSize < 1 || pageSize > 100 || pageOffset > 2147483647)
    return invalid("data.pagination");
  if (!Array.isArray(data.messages)) return invalid("data.messages");
  const messages = data.messages.map((value, index) => {
    const path = `data.messages[${index}]`;
    const row = objectAt(value, path);
    return {
      id: nonEmptyStringAt(row.id, `${path}.id`),
      sender: nonEmptyStringAt(row.sender, `${path}.sender`),
      message:
        row.message === null ? null : stringAt(row.message, `${path}.message`),
      sentAt: timestampAt(row.sentAt, `${path}.sentAt`),
    };
  });
  if (
    new Set(messages.map((message) => message.id)).size !== messages.length ||
    messages.some(
      (message, index) =>
        Date.parse(message.sentAt) < Date.parse(session.startedAt) ||
        Date.parse(message.sentAt) > Date.parse(session.lastMessageAt) ||
        (index > 0 &&
          Date.parse(messages[index - 1].sentAt) > Date.parse(message.sentAt)),
    )
  )
    return invalid("data.messages");
  const expectedLength = Math.min(
    pageSize,
    Math.max(0, session.messageCount - pageOffset),
  );
  const hasMore = booleanAt(data.hasMore, "data.hasMore");
  const nextOffset =
    data.nextOffset === null
      ? null
      : countAt(data.nextOffset, "data.nextOffset");
  const expectedMore = pageOffset + expectedLength < session.messageCount;
  if (
    messages.length !== expectedLength ||
    hasMore !== expectedMore ||
    (hasMore ? nextOffset !== pageOffset + pageSize : nextOffset !== null)
  )
    return invalid("data.pagination");
  return {
    apiVersion: "1",
    operation: "portal.getClientSessionTranscript",
    error: null,
    data: {
      success: true,
      found: true,
      authorized: true,
      operation: "portal.getClientSessionTranscript",
      db: "supabase",
      patient,
      therapist,
      sessionId,
      session,
      messages,
      pageSize,
      pageOffset,
      hasMore,
      nextOffset,
      generatedAt: timestampAt(data.generatedAt, "data.generatedAt"),
    },
  };
}

export function parseGetClientSessionsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  ClientSessionsPageData,
  "portal.getClientSessions"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getClientSessions")
    return invalid("operation");
  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getClientSessions")
    return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");
  const sessionFilter = stringAt(
    data.sessionFilter,
    "data.sessionFilter",
  ) as ClientSessionFilter;
  if (!clientSessionFilters.includes(sessionFilter))
    return invalid("data.sessionFilter");
  const countAt = (value: unknown, path: string) => {
    const count = nonNegativeIntegerAt(value, path);
    if (!Number.isSafeInteger(count)) return invalid(path);
    return count;
  };
  const timestampAt = (value: unknown, path: string) => {
    const timestamp = nonEmptyStringAt(value, path);
    if (!Number.isFinite(Date.parse(timestamp))) return invalid(path);
    return timestamp;
  };
  const pageSize = countAt(data.pageSize, "data.pageSize");
  const pageOffset = countAt(data.pageOffset, "data.pageOffset");
  if (pageSize < 1 || pageSize > 100) return invalid("data.pageSize");
  if (pageOffset > 2147483647) return invalid("data.pageOffset");
  if (!Array.isArray(data.sessions)) return invalid("data.sessions");
  const sessions = data.sessions.map((value, index) => {
    const path = `data.sessions[${index}]`;
    const row = objectAt(value, path);
    const session = {
      sessionId: nonEmptyStringAt(row.sessionId, `${path}.sessionId`),
      startedAt: timestampAt(row.startedAt, `${path}.startedAt`),
      lastMessageAt: timestampAt(row.lastMessageAt, `${path}.lastMessageAt`),
      messageCount: countAt(row.messageCount, `${path}.messageCount`),
    };
    if (
      session.messageCount < 1 ||
      Date.parse(session.startedAt) > Date.parse(session.lastMessageAt)
    ) {
      return invalid(path);
    }
    return session;
  });
  if (
    sessions.length > pageSize ||
    new Set(sessions.map((row) => row.sessionId)).size !== sessions.length
  ) {
    return invalid("data.sessions");
  }
  const hasMore = booleanAt(data.hasMore, "data.hasMore");
  const nextOffset =
    data.nextOffset === null
      ? null
      : countAt(data.nextOffset, "data.nextOffset");
  if (
    hasMore
      ? sessions.length !== pageSize || nextOffset !== pageOffset + pageSize
      : nextOffset !== null
  ) {
    return invalid("data.nextOffset");
  }
  const parsedData: ClientSessionsPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getClientSessions",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    sessionFilter,
    pageSize,
    pageOffset,
    sessions,
    hasMore,
    nextOffset,
    generatedAt: timestampAt(data.generatedAt, "data.generatedAt"),
  };
  if (
    !parsedData.found ||
    !parsedData.authorized ||
    !parsedData.patient ||
    !parsedData.therapist
  ) {
    return invalid("data.authorizedClientSessions");
  }
  return {
    apiVersion: "1",
    operation: "portal.getClientSessions",
    data: parsedData,
    error: null,
  };
}

export function parseGetHomeworkHistoryEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  HomeworkHistoryPageData,
  "portal.getHomeworkHistory"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getHomeworkHistory") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getHomeworkHistory") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.assignments)) return invalid("data.assignments");

  const parsedData: HomeworkHistoryPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getHomeworkHistory",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    historyFilter: homeworkHistoryFilterAt(
      data.historyFilter,
      "data.historyFilter",
    ),
    assignments: data.assignments.map((assignment, index) =>
      homeworkHistoryAssignmentAt(assignment, `data.assignments[${index}]`),
    ),
    ...clientRecordAccessFields(data),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || !parsedData.patient)
  ) {
    return invalid("data.authorizedHomeworkHistory");
  }

  return {
    apiVersion: "1",
    operation: "portal.getHomeworkHistory",
    data: parsedData,
    error: null,
  };
}

export function parseGetHomeworkCalendarEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  HomeworkCalendarPageData,
  "portal.getHomeworkCalendar"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getHomeworkCalendar") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getHomeworkCalendar") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.timezone !== "America/Los_Angeles") {
    return invalid("data.timezone");
  }
  if (!Array.isArray(data.homework)) return invalid("data.homework");
  if (!Array.isArray(data.unscheduledHomework)) {
    return invalid("data.unscheduledHomework");
  }
  const rangeRecord = objectAt(data.range, "data.range");
  const range = {
    startDate: calendarDateAt(rangeRecord.startDate, "data.range.startDate"),
    endDate: calendarDateAt(rangeRecord.endDate, "data.range.endDate"),
  };
  if (range.startDate > range.endDate) return invalid("data.range");
  const homework = data.homework.map((assignment, index) =>
    homeworkCalendarAssignmentAt(assignment, `data.homework[${index}]`),
  );
  if (
    homework.some(
      (assignment) =>
        assignment.calendarDate < range.startDate ||
        assignment.calendarDate > range.endDate,
    )
  ) {
    return invalid("data.homework.calendarDate");
  }
  const count = nonNegativeIntegerAt(data.count, "data.count");
  if (count !== homework.length) return invalid("data.count");
  const unscheduledHomework = data.unscheduledHomework.map(
    (assignment, index) =>
      unscheduledHomeworkAssignmentAt(
        assignment,
        `data.unscheduledHomework[${index}]`,
      ),
  );
  const unscheduledCount = nonNegativeIntegerAt(
    data.unscheduledCount,
    "data.unscheduledCount",
  );
  if (unscheduledCount !== unscheduledHomework.length) {
    return invalid("data.unscheduledCount");
  }

  const parsedData: HomeworkCalendarPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getHomeworkCalendar",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    timezone: "America/Los_Angeles",
    range,
    homework,
    count,
    unscheduledHomework,
    unscheduledCount,
    ...clientRecordAccessFields(data),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || !parsedData.patient)
  ) {
    return invalid("data.authorizedHomeworkCalendar");
  }

  return {
    apiVersion: "1",
    operation: "portal.getHomeworkCalendar",
    data: parsedData,
    error: null,
  };
}

export function parseGetCaseloadEngagementEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CaseloadEngagementPageData,
  "portal.getCaseloadEngagement"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getCaseloadEngagement") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getCaseloadEngagement") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");

  const period = caseloadEngagementPeriodAt(data.period, "data.period");
  const caseloadEngagement = caseloadEngagementReportAt(
    data.caseloadEngagement,
    "data.caseloadEngagement",
  );
  if (caseloadEngagement.period !== period) {
    return invalid("data.caseloadEngagement.period");
  }

  const parsedData: CaseloadEngagementPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getCaseloadEngagement",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    period,
    caseloadEngagement,
  };

  if (parsedData.found && parsedData.authorized && !parsedData.therapist) {
    return invalid("data.authorizedCaseloadEngagement");
  }

  return {
    apiVersion: "1",
    operation: "portal.getCaseloadEngagement",
    data: parsedData,
    error: null,
  };
}

export function parseGetDailyMoodChecksEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  DailyMoodChecksPageData,
  "portal.getDailyMoodChecks"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getDailyMoodChecks") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getDailyMoodChecks") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.moodChecks)) return invalid("data.moodChecks");

  const parsedData: DailyMoodChecksPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getDailyMoodChecks",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    moodChecks: data.moodChecks.map((moodCheck, index) =>
      dailyMoodCheckAt(moodCheck, `data.moodChecks[${index}]`),
    ),
    ...clientRecordAccessFields(data),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || !parsedData.patient)
  ) {
    return invalid("data.authorizedDailyMoodChecks");
  }

  return {
    apiVersion: "1",
    operation: "portal.getDailyMoodChecks",
    data: parsedData,
    error: null,
  };
}

export function parseGetYouthTopProblemRatingsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  YouthTopProblemRatingsPageData,
  "portal.getYouthTopProblemRatings"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getYouthTopProblemRatings") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getYouthTopProblemRatings") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.respondentType !== "client") {
    return invalid("data.respondentType");
  }
  if (!Array.isArray(data.ratings)) return invalid("data.ratings");

  const parsedData: YouthTopProblemRatingsPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getYouthTopProblemRatings",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    respondentType: "client",
    ratings: data.ratings.map((rating, index) =>
      youthTopProblemRatingAt(rating, `data.ratings[${index}]`),
    ),
    ...clientRecordAccessFields(data),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || !parsedData.patient)
  ) {
    return invalid("data.authorizedYouthTopProblemRatings");
  }

  return {
    apiVersion: "1",
    operation: "portal.getYouthTopProblemRatings",
    data: parsedData,
    error: null,
  };
}

export function parseGetExpectanciesEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<ExpectanciesPageData, "portal.getExpectancies"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getExpectancies") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getExpectancies") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.expectancies)) return invalid("data.expectancies");

  const parsedData: ExpectanciesPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getExpectancies",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    expectancies: data.expectancies.map((expectancy, index) =>
      expectancyEntryAt(expectancy, `data.expectancies[${index}]`),
    ),
    ...clientRecordAccessFields(data),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || !parsedData.patient)
  ) {
    return invalid("data.authorizedExpectancies");
  }

  return {
    apiVersion: "1",
    operation: "portal.getExpectancies",
    data: parsedData,
    error: null,
  };
}

export function parseGetHomeworkAnalysesEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  HomeworkAnalysesPageData,
  "portal.getHomeworkAnalyses"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getHomeworkAnalyses") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getHomeworkAnalyses") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.analyses)) return invalid("data.analyses");

  const parsedData: HomeworkAnalysesPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getHomeworkAnalyses",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    analyses: data.analyses.map((analysis, index) =>
      homeworkAnalysisAt(analysis, `data.analyses[${index}]`),
    ),
    ...clientRecordAccessFields(data),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || !parsedData.patient)
  ) {
    return invalid("data.authorizedHomeworkAnalyses");
  }

  return {
    apiVersion: "1",
    operation: "portal.getHomeworkAnalyses",
    data: parsedData,
    error: null,
  };
}

export function parseGenerateHomeworkAnalysisEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  GenerateHomeworkAnalysisData,
  "portal.generateHomeworkAnalysis"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.generateHomeworkAnalysis") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.generateHomeworkAnalysis") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.generated !== true) return invalid("data.generated");

  const recordCount = finiteNumberAt(data.recordCount, "data.recordCount");
  if (!Number.isInteger(recordCount) || recordCount < 0) {
    return invalid("data.recordCount");
  }

  const parsedData: GenerateHomeworkAnalysisData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.generateHomeworkAnalysis",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    generated: true,
    recordCount,
    analysis: homeworkAnalysisAt(data.analysis, "data.analysis"),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist ||
      !parsedData.patient ||
      !parsedData.analysis.analysis.trim() ||
      !parsedData.analysis.triggerSource.trim())
  ) {
    return invalid("data.authorizedGeneratedHomeworkAnalysis");
  }

  return {
    apiVersion: "1",
    operation: "portal.generateHomeworkAnalysis",
    data: parsedData,
    error: null,
  };
}

export function parseGetActivityRegistryEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  ActivityRegistryPageData,
  "portal.admin.getActivityRegistry"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.getActivityRegistry") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.admin.getActivityRegistry") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (!Array.isArray(data.activities)) return invalid("data.activities");

  const parsedData: ActivityRegistryPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.admin.getActivityRegistry",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    activities: data.activities.map((activity, index) =>
      activityRegistryItemAt(activity, `data.activities[${index}]`),
    ),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist ||
      parsedData.therapist.role.trim().toLowerCase() !== "admin")
  ) {
    return invalid("data.authorizedActivityRegistry");
  }

  return {
    apiVersion: "1",
    operation: "portal.admin.getActivityRegistry",
    data: parsedData,
    error: null,
  };
}

export function parseGetLovCatalogsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  LovCatalogsPageData,
  "portal.admin.getLovCatalogs"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.getLovCatalogs") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.admin.getLovCatalogs") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (!Array.isArray(data.catalogs)) return invalid("data.catalogs");

  const parsedData: LovCatalogsPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.admin.getLovCatalogs",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    catalogs: data.catalogs.map((catalog, index) =>
      lovCatalogAt(catalog, `data.catalogs[${index}]`),
    ),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || parsedData.therapist.role !== "admin")
  ) {
    return invalid("data.authorizedLovCatalogs");
  }

  return {
    apiVersion: "1",
    operation: "portal.admin.getLovCatalogs",
    data: parsedData,
    error: null,
  };
}

export function parseGetLovOptionsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  LovOptionsPageData,
  "portal.admin.getLovOptions"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.getLovOptions") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.admin.getLovOptions") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (!Array.isArray(data.options)) return invalid("data.options");

  const catalogKey = nonEmptyStringAt(data.catalogKey, "data.catalogKey");
  const catalog = lovCatalogAt(data.catalog, "data.catalog");
  if (catalog.key !== catalogKey) return invalid("data.catalog.key");

  const parsedData: LovOptionsPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.admin.getLovOptions",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    catalogKey,
    catalog,
    options: data.options.map((option, index) =>
      lovOptionAt(option, `data.options[${index}]`),
    ),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || parsedData.therapist.role !== "admin")
  ) {
    return invalid("data.authorizedLovOptions");
  }

  return {
    apiVersion: "1",
    operation: "portal.admin.getLovOptions",
    data: parsedData,
    error: null,
  };
}

function lovOptionWriteFieldsAt(
  data: JsonObject,
  operation:
    | "portal.admin.createLovOption"
    | "portal.admin.updateLovOption"
    | "portal.admin.setLovOptionEnabled",
  resultFlag: "created" | "updated",
) {
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (data[resultFlag] !== true) return invalid(`data.${resultFlag}`);

  const catalogKey = nonEmptyStringAt(data.catalogKey, "data.catalogKey");
  const catalog = lovCatalogAt(data.catalog, "data.catalog");
  if (catalog.key !== catalogKey) return invalid("data.catalog.key");

  const fields = {
    success: true as const,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    db: "supabase" as const,
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    catalogKey,
    catalog,
    option: lovOptionAt(data.option, "data.option"),
  };

  if (
    !fields.found ||
    !fields.authorized ||
    !fields.therapist ||
    fields.therapist.role !== "admin"
  ) {
    return invalid("data.authorizedLovOptionWrite");
  }

  return fields;
}

export function parseCreateLovOptionEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CreateLovOptionData,
  "portal.admin.createLovOption"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.createLovOption") {
    return invalid("operation");
  }

  const fields = lovOptionWriteFieldsAt(
    objectAt(record.data, "data"),
    "portal.admin.createLovOption",
    "created",
  );
  const data: CreateLovOptionData = {
    ...fields,
    created: true,
    operation: "portal.admin.createLovOption",
  };

  return {
    apiVersion: "1",
    operation: "portal.admin.createLovOption",
    data,
    error: null,
  };
}

export function parseUpdateLovOptionEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  UpdateLovOptionData,
  "portal.admin.updateLovOption"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.updateLovOption") {
    return invalid("operation");
  }

  const fields = lovOptionWriteFieldsAt(
    objectAt(record.data, "data"),
    "portal.admin.updateLovOption",
    "updated",
  );
  const data: UpdateLovOptionData = {
    ...fields,
    updated: true,
    operation: "portal.admin.updateLovOption",
  };

  return {
    apiVersion: "1",
    operation: "portal.admin.updateLovOption",
    data,
    error: null,
  };
}

export function parseSetLovOptionEnabledEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SetLovOptionEnabledData,
  "portal.admin.setLovOptionEnabled"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.setLovOptionEnabled") {
    return invalid("operation");
  }

  const fields = lovOptionWriteFieldsAt(
    objectAt(record.data, "data"),
    "portal.admin.setLovOptionEnabled",
    "updated",
  );
  const data: SetLovOptionEnabledData = {
    ...fields,
    updated: true,
    operation: "portal.admin.setLovOptionEnabled",
  };

  return {
    apiVersion: "1",
    operation: "portal.admin.setLovOptionEnabled",
    data,
    error: null,
  };
}

export function parseGetTherapistsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  TherapistsPageData,
  "portal.admin.getTherapists"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.getTherapists") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.admin.getTherapists") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (!Array.isArray(data.therapists)) return invalid("data.therapists");

  const parsedData: TherapistsPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.admin.getTherapists",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    therapists: data.therapists.map((therapist, index) =>
      therapistAt(therapist, `data.therapists[${index}]`),
    ),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || parsedData.therapist.role !== "admin")
  ) {
    return invalid("data.authorizedTherapists");
  }

  return {
    apiVersion: "1",
    operation: "portal.admin.getTherapists",
    data: parsedData,
    error: null,
  };
}

export function parseGetAllClientsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  AdminClientsPageData,
  "portal.admin.getAllClients"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.getAllClients") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.admin.getAllClients") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.patients)) return invalid("data.patients");

  const totalCount =
    data.totalCount === undefined
      ? undefined
      : nonNegativeIntegerAt(data.totalCount, "data.totalCount");
  const parsedData: AdminClientsPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.admin.getAllClients",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patients: data.patients.map((patient, index) =>
      adminClientPatientAt(patient, `data.patients[${index}]`),
    ),
    ...(totalCount === undefined ? {} : { totalCount }),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || parsedData.therapist.role !== "admin")
  ) {
    return invalid("data.authorizedClients");
  }

  return {
    apiVersion: "1",
    operation: "portal.admin.getAllClients",
    data: parsedData,
    error: null,
  };
}

export function parseGetClinicsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<ClinicsPageData, "portal.admin.getClinics"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.getClinics") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.admin.getClinics") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (!Array.isArray(data.clinics)) return invalid("data.clinics");

  const parsedData: ClinicsPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.admin.getClinics",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    clinics: data.clinics.map((clinic, index) =>
      clinicAt(clinic, `data.clinics[${index}]`),
    ),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || parsedData.therapist.role !== "admin")
  ) {
    return invalid("data.authorizedClinics");
  }

  return {
    apiVersion: "1",
    operation: "portal.admin.getClinics",
    data: parsedData,
    error: null,
  };
}

export function parseCreateClinicEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<CreateClinicData, "portal.admin.createClinic"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.createClinic") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.admin.createClinic") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (data.created !== true) return invalid("data.created");

  const parsedData: CreateClinicData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    created: true,
    operation: "portal.admin.createClinic",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    clinic: clinicAt(data.clinic, "data.clinic"),
  };

  if (
    !parsedData.found ||
    !parsedData.authorized ||
    !parsedData.therapist ||
    parsedData.therapist.role !== "admin"
  ) {
    return invalid("data.authorizedClinicCreate");
  }
  if (!parsedData.clinic.therapistIds) {
    return invalid("data.clinic.therapistIds");
  }
  if (
    parsedData.clinic.therapistCount !== parsedData.clinic.therapistIds.length
  ) {
    return invalid("data.clinic.therapistCount");
  }

  return {
    apiVersion: "1",
    operation: "portal.admin.createClinic",
    data: parsedData,
    error: null,
  };
}

export function parseUpdateClinicEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<UpdateClinicData, "portal.admin.updateClinic"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.updateClinic") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.admin.updateClinic") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (data.updated !== true) return invalid("data.updated");

  const parsedData: UpdateClinicData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    updated: true,
    operation: "portal.admin.updateClinic",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    clinic: clinicAt(data.clinic, "data.clinic"),
  };

  if (
    !parsedData.found ||
    !parsedData.authorized ||
    !parsedData.therapist ||
    parsedData.therapist.role !== "admin"
  ) {
    return invalid("data.authorizedClinicUpdate");
  }
  if (
    parsedData.clinic.therapistCount !== parsedData.clinic.therapistIds.length
  ) {
    return invalid("data.clinic.therapistCount");
  }

  return {
    apiVersion: "1",
    operation: "portal.admin.updateClinic",
    data: parsedData,
    error: null,
  };
}

export function parseCreateTherapistEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CreateTherapistData,
  "portal.admin.createTherapist"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.createTherapist") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.admin.createTherapist") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (data.created !== true) return invalid("data.created");

  const parsedData: CreateTherapistData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    created: true,
    operation: "portal.admin.createTherapist",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    createdTherapist: createdTherapistAt(
      data.createdTherapist,
      "data.createdTherapist",
    ),
  };

  if (
    !parsedData.found ||
    !parsedData.authorized ||
    !parsedData.therapist ||
    parsedData.therapist.role !== "admin"
  ) {
    return invalid("data.authorizedTherapistCreate");
  }

  return {
    apiVersion: "1",
    operation: "portal.admin.createTherapist",
    data: parsedData,
    error: null,
  };
}

export function parseUpdateTherapistEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  UpdateTherapistData,
  "portal.admin.updateTherapist"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.admin.updateTherapist") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.admin.updateTherapist") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");
  if (data.updated !== true) return invalid("data.updated");

  const parsedData: UpdateTherapistData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    updated: true,
    operation: "portal.admin.updateTherapist",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    updatedTherapist: createdTherapistAt(
      data.updatedTherapist,
      "data.updatedTherapist",
    ),
  };

  if (
    !parsedData.found ||
    !parsedData.authorized ||
    !parsedData.therapist ||
    parsedData.therapist.role !== "admin"
  ) {
    return invalid("data.authorizedTherapistUpdate");
  }

  return {
    apiVersion: "1",
    operation: "portal.admin.updateTherapist",
    data: parsedData,
    error: null,
  };
}

export function parseGetActivityTemplatesEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  ActivityTemplatesPageData,
  "portal.getActivityTemplates"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getActivityTemplates") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getActivityTemplates") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.templates)) return invalid("data.templates");

  const parsedData: ActivityTemplatesPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getActivityTemplates",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    templates: data.templates.map((template, index) =>
      activityTemplateSummaryAt(template, `data.templates[${index}]`),
    ),
  };

  if (parsedData.found && parsedData.authorized && !parsedData.therapist) {
    return invalid("data.authorizedActivityTemplates");
  }

  return {
    apiVersion: "1",
    operation: "portal.getActivityTemplates",
    data: parsedData,
    error: null,
  };
}

export function parseGetActivityTemplateEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  ActivityTemplateDetailPageData,
  "portal.getActivityTemplate"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getActivityTemplate") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.operation !== "portal.getActivityTemplate") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");

  const parsedData: ActivityTemplateDetailPageData = {
    success: booleanAt(data.success, "data.success"),
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getActivityTemplate",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    template:
      data.template === null
        ? null
        : activityTemplateDetailAt(data.template, "data.template"),
    ...(data.error === undefined
      ? {}
      : { error: stringAt(data.error, "data.error") }),
  };

  if (
    parsedData.success &&
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || !parsedData.template)
  ) {
    return invalid("data.authorizedActivityTemplate");
  }

  return {
    apiVersion: "1",
    operation: "portal.getActivityTemplate",
    data: parsedData,
    error: null,
  };
}

export function parseGetActivityTypesEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  ActivityTypesPageData,
  "portal.getActivityTypes"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getActivityTypes") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getActivityTypes") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.activityTypes)) return invalid("data.activityTypes");

  const parsedData: ActivityTypesPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getActivityTypes",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    activityTypes: data.activityTypes.map((activityType, index) =>
      activityTypeAt(activityType, `data.activityTypes[${index}]`),
    ),
  };

  if (parsedData.found && parsedData.authorized && !parsedData.therapist) {
    return invalid("data.authorizedActivityTypes");
  }

  return {
    apiVersion: "1",
    operation: "portal.getActivityTypes",
    data: parsedData,
    error: null,
  };
}

function activityTemplateMutationAt(
  data: JsonObject,
  operation: "portal.createActivityTemplate" | "portal.updateActivityTemplate",
  resultKey: "created" | "updated",
) {
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");

  const success = booleanAt(data.success, "data.success");
  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const completed = booleanAt(data[resultKey], `data.${resultKey}`);
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const template =
    data.template === null
      ? null
      : activityTemplateRecordAt(data.template, "data.template");
  const error = mutationErrorAt(data, "data");

  if (
    success &&
    completed &&
    (!found || !authorized || !therapist || !template)
  ) {
    return invalid("data.successfulActivityTemplateMutation");
  }

  return {
    success,
    found,
    authorized,
    db: "supabase" as const,
    therapist,
    template,
    completed,
    error,
  };
}

export function parseCreateActivityTemplateEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CreateActivityTemplateData,
  "portal.createActivityTemplate"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.createActivityTemplate") {
    return invalid("operation");
  }

  const parsed = activityTemplateMutationAt(
    objectAt(record.data, "data"),
    "portal.createActivityTemplate",
    "created",
  );
  const parsedData: CreateActivityTemplateData = {
    success: parsed.success,
    found: parsed.found,
    authorized: parsed.authorized,
    created: parsed.completed,
    operation: "portal.createActivityTemplate",
    db: "supabase",
    therapist: parsed.therapist,
    template: parsed.template,
    ...(parsed.error === undefined ? {} : { error: parsed.error }),
  };

  return {
    apiVersion: "1",
    operation: "portal.createActivityTemplate",
    data: parsedData,
    error: null,
  };
}

export function parseUpdateActivityTemplateEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  UpdateActivityTemplateData,
  "portal.updateActivityTemplate"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.updateActivityTemplate") {
    return invalid("operation");
  }

  const parsed = activityTemplateMutationAt(
    objectAt(record.data, "data"),
    "portal.updateActivityTemplate",
    "updated",
  );
  const parsedData: UpdateActivityTemplateData = {
    success: parsed.success,
    found: parsed.found,
    authorized: parsed.authorized,
    updated: parsed.completed,
    operation: "portal.updateActivityTemplate",
    db: "supabase",
    therapist: parsed.therapist,
    template: parsed.template,
    ...(parsed.error === undefined ? {} : { error: parsed.error }),
  };

  return {
    apiVersion: "1",
    operation: "portal.updateActivityTemplate",
    data: parsedData,
    error: null,
  };
}

function activityStepsMutationRecordAt(value: unknown, path: string) {
  const record = objectAt(value, path);
  return {
    id: nonEmptyStringAt(record.id, `${path}.id`),
    activitySteps: stringAt(record.activitySteps, `${path}.activitySteps`),
  };
}

export function parseUpdateActivityTemplateStepsEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  UpdateActivityTemplateStepsData,
  "portal.updateActivityTemplateSteps"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.updateActivityTemplateSteps") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.operation !== "portal.updateActivityTemplateSteps") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (data.patient !== null) return invalid("data.patient");

  const parsedData: UpdateActivityTemplateStepsData = {
    success: booleanAt(data.success, "data.success"),
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.updateActivityTemplateSteps",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: null,
    template:
      data.template === null
        ? null
        : activityStepsMutationRecordAt(data.template, "data.template"),
    ...(data.error === undefined
      ? {}
      : { error: stringAt(data.error, "data.error") }),
  };

  if (
    parsedData.success &&
    (!parsedData.found ||
      !parsedData.authorized ||
      !parsedData.therapist ||
      !parsedData.template)
  ) {
    return invalid("data.successfulActivityTemplateStepsUpdate");
  }

  return {
    apiVersion: "1",
    operation: "portal.updateActivityTemplateSteps",
    data: parsedData,
    error: null,
  };
}

function activityTemplateImageMutationAt(
  data: JsonObject,
  operation:
    | "portal.uploadActivityTemplateImage"
    | "portal.deleteActivityTemplateImage",
  resultKey: "uploaded" | "deleted",
) {
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");

  const success = booleanAt(data.success, "data.success");
  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const completed = booleanAt(data[resultKey], `data.${resultKey}`);
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const templateId = nonEmptyStringAt(data.templateId, "data.templateId");
  const error = mutationErrorAt(data, "data");

  if (success && completed && (!found || !authorized || !therapist)) {
    return invalid("data.successfulActivityTemplateImageMutation");
  }

  return {
    data,
    success,
    found,
    authorized,
    completed,
    therapist,
    templateId,
    error,
  };
}

export function parseUploadActivityTemplateImageEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  UploadActivityTemplateImageData,
  "portal.uploadActivityTemplateImage"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.uploadActivityTemplateImage") {
    return invalid("operation");
  }
  const parsed = activityTemplateImageMutationAt(
    objectAt(record.data, "data"),
    "portal.uploadActivityTemplateImage",
    "uploaded",
  );
  const parsedData: UploadActivityTemplateImageData = {
    success: parsed.success,
    found: parsed.found,
    authorized: parsed.authorized,
    uploaded: parsed.completed,
    operation: "portal.uploadActivityTemplateImage",
    db: "supabase",
    therapist: parsed.therapist,
    templateId: parsed.templateId,
    image:
      parsed.data.image === null
        ? null
        : activityImageAt(parsed.data.image, "data.image"),
    ...(parsed.error === undefined ? {} : { error: parsed.error }),
  };
  if (parsedData.success && parsedData.uploaded && !parsedData.image) {
    return invalid("data.image");
  }
  return {
    apiVersion: "1",
    operation: "portal.uploadActivityTemplateImage",
    data: parsedData,
    error: null,
  };
}

export function parseDeleteActivityTemplateImageEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  DeleteActivityTemplateImageData,
  "portal.deleteActivityTemplateImage"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.deleteActivityTemplateImage") {
    return invalid("operation");
  }
  const parsed = activityTemplateImageMutationAt(
    objectAt(record.data, "data"),
    "portal.deleteActivityTemplateImage",
    "deleted",
  );
  const parsedData: DeleteActivityTemplateImageData = {
    success: parsed.success,
    found: parsed.found,
    authorized: parsed.authorized,
    deleted: parsed.completed,
    operation: "portal.deleteActivityTemplateImage",
    db: "supabase",
    therapist: parsed.therapist,
    templateId: parsed.templateId,
    imageId: nonEmptyStringAt(parsed.data.imageId, "data.imageId"),
    ...(parsed.error === undefined ? {} : { error: parsed.error }),
  };
  return {
    apiVersion: "1",
    operation: "portal.deleteActivityTemplateImage",
    data: parsedData,
    error: null,
  };
}

function homeworkImageMutationAt(
  data: JsonObject,
  operation: "portal.uploadHomeworkImage" | "portal.deleteHomeworkImage",
  resultKey: "uploaded" | "deleted",
) {
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");

  const success = booleanAt(data.success, "data.success");
  const found = booleanAt(data.found, "data.found");
  const authorized = booleanAt(data.authorized, "data.authorized");
  const completed = booleanAt(data[resultKey], `data.${resultKey}`);
  const therapist = nullableTherapistAt(data.therapist, "data.therapist");
  const patient = nullablePatientAt(data.patient, "data.patient");
  const homeworkAssignmentId = nonEmptyStringAt(
    data.homeworkAssignmentId,
    "data.homeworkAssignmentId",
  );
  const error = mutationErrorAt(data, "data");

  if (
    success &&
    completed &&
    (!found || !authorized || !therapist || !patient)
  ) {
    return invalid("data.successfulHomeworkImageMutation");
  }

  return {
    data,
    success,
    found,
    authorized,
    completed,
    therapist,
    patient,
    homeworkAssignmentId,
    error,
  };
}

export function parseUploadHomeworkImageEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  UploadHomeworkImageData,
  "portal.uploadHomeworkImage"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.uploadHomeworkImage") {
    return invalid("operation");
  }

  const parsed = homeworkImageMutationAt(
    objectAt(record.data, "data"),
    "portal.uploadHomeworkImage",
    "uploaded",
  );
  const parsedData: UploadHomeworkImageData = {
    success: parsed.success,
    found: parsed.found,
    authorized: parsed.authorized,
    uploaded: parsed.completed,
    operation: "portal.uploadHomeworkImage",
    db: "supabase",
    therapist: parsed.therapist,
    patient: parsed.patient,
    homeworkAssignmentId: parsed.homeworkAssignmentId,
    image:
      parsed.data.image === null
        ? null
        : activityImageAt(parsed.data.image, "data.image"),
    ...(parsed.error === undefined ? {} : { error: parsed.error }),
  };
  if (parsedData.success && parsedData.uploaded && !parsedData.image) {
    return invalid("data.image");
  }

  return {
    apiVersion: "1",
    operation: "portal.uploadHomeworkImage",
    data: parsedData,
    error: null,
  };
}

export function parseDeleteHomeworkImageEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  DeleteHomeworkImageData,
  "portal.deleteHomeworkImage"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.deleteHomeworkImage") {
    return invalid("operation");
  }

  const parsed = homeworkImageMutationAt(
    objectAt(record.data, "data"),
    "portal.deleteHomeworkImage",
    "deleted",
  );
  const parsedData: DeleteHomeworkImageData = {
    success: parsed.success,
    found: parsed.found,
    authorized: parsed.authorized,
    deleted: parsed.completed,
    operation: "portal.deleteHomeworkImage",
    db: "supabase",
    therapist: parsed.therapist,
    patient: parsed.patient,
    homeworkAssignmentId: parsed.homeworkAssignmentId,
    imageId: nonEmptyStringAt(parsed.data.imageId, "data.imageId"),
    ...(parsed.error === undefined ? {} : { error: parsed.error }),
  };

  return {
    apiVersion: "1",
    operation: "portal.deleteHomeworkImage",
    data: parsedData,
    error: null,
  };
}

export function parseGetHomeworkActivitiesEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  HomeworkActivitiesPageData,
  "portal.getHomeworkActivities"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getHomeworkActivities") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getHomeworkActivities") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");
  if (!Array.isArray(data.assignments)) return invalid("data.assignments");

  const parsedData: HomeworkActivitiesPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getHomeworkActivities",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    assignments: data.assignments.map((assignment, index) =>
      homeworkActivitiesListAssignmentAt(
        assignment,
        `data.assignments[${index}]`,
      ),
    ),
  };

  if (parsedData.found && parsedData.authorized && !parsedData.therapist) {
    return invalid("data.authorizedHomeworkActivities");
  }

  return {
    apiVersion: "1",
    operation: "portal.getHomeworkActivities",
    data: parsedData,
    error: null,
  };
}

export function parseGetHomeworkDetailEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  HomeworkDetailPageData,
  "portal.getHomeworkDetail"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.getHomeworkDetail") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.success !== true) return invalid("data.success");
  if (data.operation !== "portal.getHomeworkDetail") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");

  const parsedData: HomeworkDetailPageData = {
    success: true,
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.getHomeworkDetail",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    homework:
      data.homework === null
        ? null
        : homeworkDetailAt(data.homework, "data.homework"),
    ...clientRecordAccessFields(data),
  };

  if (
    parsedData.found &&
    parsedData.authorized &&
    (!parsedData.therapist || !parsedData.patient || !parsedData.homework)
  ) {
    return invalid("data.authorizedHomeworkDetail");
  }

  return {
    apiVersion: "1",
    operation: "portal.getHomeworkDetail",
    data: parsedData,
    error: null,
  };
}

function homeworkMutationBaseAt(
  data: JsonObject,
  operation: "portal.createHomework" | "portal.selectHomeworkTemplate",
) {
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");

  const parsed = {
    success: booleanAt(data.success, "data.success"),
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    db: "supabase" as const,
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    homework: nullableMutationHomeworkAt(data.homework, "data.homework"),
    error: mutationErrorAt(data, "data"),
  };

  if (
    parsed.success &&
    (!parsed.found ||
      !parsed.authorized ||
      !parsed.therapist ||
      !parsed.patient ||
      !parsed.homework)
  ) {
    return invalid("data.successfulMutation");
  }

  return parsed;
}

export function parseCreateHomeworkEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<CreateHomeworkData, "portal.createHomework"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.createHomework") return invalid("operation");

  const data = objectAt(record.data, "data");
  const parsed = homeworkMutationBaseAt(data, "portal.createHomework");
  const parsedData: CreateHomeworkData = {
    ...parsed,
    operation: "portal.createHomework",
    ...(parsed.error === undefined ? {} : { error: parsed.error }),
  };

  return {
    apiVersion: "1",
    operation: "portal.createHomework",
    data: parsedData,
    error: null,
  };
}

export function parseCreateHomeworkActivityEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  CreateHomeworkActivityData,
  "portal.createHomeworkActivity"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.createHomeworkActivity") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.operation !== "portal.createHomeworkActivity") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");

  const parsedData: CreateHomeworkActivityData = {
    success: booleanAt(data.success, "data.success"),
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    created: booleanAt(data.created, "data.created"),
    operation: "portal.createHomeworkActivity",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    homework: nullableMutationHomeworkAt(data.homework, "data.homework"),
    ...(data.error === undefined
      ? {}
      : { error: stringAt(data.error, "data.error") }),
  };

  if (
    parsedData.success &&
    (!parsedData.found ||
      !parsedData.authorized ||
      !parsedData.created ||
      !parsedData.therapist ||
      !parsedData.patient ||
      !parsedData.homework)
  ) {
    return invalid("data.successfulHomeworkActivityCreate");
  }

  return {
    apiVersion: "1",
    operation: "portal.createHomeworkActivity",
    data: parsedData,
    error: null,
  };
}

export function parseSelectHomeworkTemplateEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  SelectHomeworkTemplateData,
  "portal.selectHomeworkTemplate"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.selectHomeworkTemplate") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  const parsed = homeworkMutationBaseAt(data, "portal.selectHomeworkTemplate");
  const template = nullableMutationHomeworkAt(data.template, "data.template");
  if (parsed.success && !template) return invalid("data.template");

  const parsedData: SelectHomeworkTemplateData = {
    ...parsed,
    operation: "portal.selectHomeworkTemplate",
    template,
    ...(parsed.error === undefined ? {} : { error: parsed.error }),
  };

  return {
    apiVersion: "1",
    operation: "portal.selectHomeworkTemplate",
    data: parsedData,
    error: null,
  };
}

function parseHomeworkUpdateEnvelope(
  value: unknown,
  operation: "portal.updateHomework",
): ClinicianPortalApiEnvelope<UpdateHomeworkData, "portal.updateHomework"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record) as never;
  if (record.operation !== operation) return invalid("operation");

  const data = objectAt(record.data, "data");
  if (data.operation !== operation) return invalid("data.operation");
  if (data.db !== "supabase") return invalid("data.db");

  const parsed = {
    success: booleanAt(data.success, "data.success"),
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    updated: booleanAt(data.updated, "data.updated"),
    operation,
    db: "supabase" as const,
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    homework:
      data.homework === null
        ? null
        : homeworkDetailAt(data.homework, "data.homework"),
    ...(data.error === undefined
      ? {}
      : { error: stringAt(data.error, "data.error") }),
  };

  if (
    parsed.success &&
    (!parsed.found ||
      !parsed.authorized ||
      !parsed.updated ||
      !parsed.therapist ||
      !parsed.patient ||
      !parsed.homework)
  ) {
    return invalid("data.successfulHomeworkUpdate");
  }

  return {
    apiVersion: "1",
    operation,
    data: parsed,
    error: null,
  };
}

export function parseUpdateHomeworkEnvelope(value: unknown) {
  return parseHomeworkUpdateEnvelope(value, "portal.updateHomework");
}

export function parseUpdateHomeworkStepsEnvelope(value: unknown) {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.updateHomeworkSteps") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.operation !== "portal.updateHomeworkSteps") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");

  const parsedData: UpdateHomeworkStepsData = {
    success: booleanAt(data.success, "data.success"),
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.updateHomeworkSteps",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    homework:
      data.homework === null
        ? null
        : activityStepsMutationRecordAt(data.homework, "data.homework"),
    ...(data.error === undefined
      ? {}
      : { error: stringAt(data.error, "data.error") }),
  };

  if (
    parsedData.success &&
    (!parsedData.found ||
      !parsedData.authorized ||
      !parsedData.therapist ||
      !parsedData.patient ||
      !parsedData.homework)
  ) {
    return invalid("data.successfulHomeworkStepsUpdate");
  }

  return {
    apiVersion: "1",
    operation: "portal.updateHomeworkSteps",
    data: parsedData,
    error: null,
  };
}

export function parseDuplicateHomeworkEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<
  DuplicateHomeworkData,
  "portal.duplicateHomework"
> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.duplicateHomework") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.operation !== "portal.duplicateHomework") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");

  const parsedData: DuplicateHomeworkData = {
    success: booleanAt(data.success, "data.success"),
    duplicated: booleanAt(data.duplicated, "data.duplicated"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.duplicateHomework",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    sourceHomeworkId: nonEmptyStringAt(
      data.sourceHomeworkId,
      "data.sourceHomeworkId",
    ),
    homework: nullableMutationHomeworkAt(data.homework, "data.homework"),
    activityImageCount: finiteNumberAt(
      data.activityImageCount,
      "data.activityImageCount",
    ),
    ...(data.error === undefined
      ? {}
      : { error: stringAt(data.error, "data.error") }),
  };

  if (
    !Number.isInteger(parsedData.activityImageCount) ||
    parsedData.activityImageCount < 0
  ) {
    return invalid("data.activityImageCount");
  }

  if (
    parsedData.success &&
    (!parsedData.duplicated ||
      !parsedData.authorized ||
      !parsedData.therapist ||
      !parsedData.patient ||
      !parsedData.homework ||
      !parsedData.sourceHomeworkId)
  ) {
    return invalid("data.successfulDuplicate");
  }

  return {
    apiVersion: "1",
    operation: "portal.duplicateHomework",
    data: parsedData,
    error: null,
  };
}

export function parseDeleteHomeworkEnvelope(
  value: unknown,
): ClinicianPortalApiEnvelope<DeleteHomeworkData, "portal.deleteHomework"> {
  const record = envelopeRecordAt(value);
  if (record.error !== null) return failureAt(record);
  if (record.operation !== "portal.deleteHomework") {
    return invalid("operation");
  }

  const data = objectAt(record.data, "data");
  if (data.operation !== "portal.deleteHomework") {
    return invalid("data.operation");
  }
  if (data.db !== "supabase") return invalid("data.db");

  const parsedData: DeleteHomeworkData = {
    success: booleanAt(data.success, "data.success"),
    found: booleanAt(data.found, "data.found"),
    authorized: booleanAt(data.authorized, "data.authorized"),
    operation: "portal.deleteHomework",
    db: "supabase",
    therapist: nullableTherapistAt(data.therapist, "data.therapist"),
    patient: nullablePatientAt(data.patient, "data.patient"),
    deleted: booleanAt(data.deleted, "data.deleted"),
    homeworkAssignmentId: nonEmptyStringAt(
      data.homeworkAssignmentId,
      "data.homeworkAssignmentId",
    ),
    ...(data.error === undefined
      ? {}
      : { error: stringAt(data.error, "data.error") }),
  };

  if (
    parsedData.success &&
    (!parsedData.found ||
      !parsedData.authorized ||
      !parsedData.therapist ||
      !parsedData.patient ||
      !parsedData.deleted)
  ) {
    return invalid("data.successfulDelete");
  }

  return {
    apiVersion: "1",
    operation: "portal.deleteHomework",
    data: parsedData,
    error: null,
  };
}
